import { useSelector } from "react-redux";
import { selectCurrent } from "../../../redux/settings/selectors";
import { selectWebsiteCardsListItems } from "../../../redux/websiteCards/selector";
import { useEffect, useState } from "react";
import storePersist from "../../../redux/storePersist";
import { useAppDispatch } from "../../../hooks/hooks";
import { websiteCards } from "../../../redux/websiteCards/action";
import _ from 'lodash'
import { getCardData } from "../../../common/services/website-card.service";
import { guestToken } from "../../../redux/auth/actions";
import { queryByStore } from "../../../redux/query-by-store/action";
import { organizationUnits } from "../../../redux/organizationUnits/action";
import { library } from "../../../redux/library/action";
import { countries } from "../../../redux/countries/action";
import { states } from "../../../redux/states/action";
import { websites } from "../../../redux/websites/action";
import { settings } from "../../../redux/settings/actions";
import GetQuote from "../../../models/GetQuote";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import GoogleMapSearch from "../../../common/components/google-map-search";
import { leads } from "../../../redux/leads/action";
import { cmsSettings } from "../../../redux/cmsSettings/action";
import useWindowDimensions from "../../../hooks/useWindowsDimensions";
import { useNavigate } from "react-router-dom";
import { selectOrganizationUnitsListItems } from "../../../redux/organizationUnits/selector";
import PageLoader from "../../../components/PageLoader";
import moment from "moment";
import { getHostName, getOrigin } from "../../../common/services/common.service";
const slider1 = require('./../../../assets/img/slider1.png')
const slider2 = require('./../../../assets/img/slider2.png')
const banner = require('./../../../assets/img/logisticsBanner.png')

const LogisticHome = () => {
	const dispatch = useAppDispatch()
	let navigate = useNavigate()
	const [isLoading, setIsLoading] = useState<boolean>(true)
	const { height, width } = useWindowDimensions();
	//const { result } = useSelector(selectCurrent)
	const [color, setColor] = useState('universal')
	const defaultSetting = useSelector(selectCurrent)
	const { theme, primary, secondary } = defaultSetting
	const [logo, setLogo] = useState<any>()
	const organizationLists = useSelector(selectOrganizationUnitsListItems)
	const websiteCardsList = useSelector(selectWebsiteCardsListItems)
	const [index, setIndex] = useState(0);
	const [generateIds, setGenerateIds] = useState<any>([]);
	const [leadValues, setLeadValues] = useState<any>()
	const [tenantId, setTenantId] = useState<Number>();

	const [isMandatoryApiCallsCompleted, setIsMandatoryApiCallsCompleted] = useState<boolean>(false);
	const [searchedLocation, setSearchedLocation] = useState({
		name: '',
		lat: '',
		long: '',
		pincode: '',
		description: '',
	});


	const [searchedToLocation, setSearchedToLocation] = useState({
		name: '',
		lat: '',
		long: '',
		pincode: '',
		description: '',
	});

	const handleChange: any = (event: any, field: string) => {
		setLeadValues({ ...leadValues, [field]: event })
	}

	// Guest API
	const getGuestToken = async () => {
		await dispatch(guestToken({
			loginData: [
				{
					"Context": {
						"domain": "string",
						"core_version": "string",
						"bap_id": getHostName(),
						"bap_uri": getOrigin(),
						"bpp_id": "string",
						"bpp_uri": "string",
						"city": "string",
						"country": "string",
						"action": "string",
						"transaction_id": "string",
						"message_id": "string",
						"timestamp": moment.utc(),
						"ttl": "string",
						"Subscription": "Logisitcs",
						"Domain": "Logisitcs",
						"SubDomains": [
							"Delivery"
						],
						"Network": "Logistics_Customer",
						"Application": "Customer",
						"Channel": "CSP"
					},
					"Message": {
						"AccountType": "Logistics_Customer"
					}
				}
			]
		}));
	}
	// Mandatory API
	const mandatoryAPICalls = async () => {
		setIsMandatoryApiCallsCompleted(false);
		if (storePersist.get('guestTokenMetadata').current?.success) {
			await dispatch(websites.list({
				url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-websites/list`, entity: 'websites', jsonData: {

					"Filters": [
						{
							"FieldName": "PlatformWebSiteId",
							"FilterOperatorId": 1,
							"FieldValue": 30,
							"FieldType": "number"
						}
					],

				}
			}))

			await dispatch(websiteCards.list({
				url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/web-platform/tenant-website-cards/list`, entity: 'websiteCards', jsonData: {

					"Filters": [
						{
							"FieldName": "WebsiteName",
							"FilterOperatorId": 1,
							"FieldValue": storePersist?.get("websites")?.current[0]?.WebSiteName,
							"FieldType": "text"
						}
					]

				}
			}))
			await setIsLoading(false)
		}
		setIsMandatoryApiCallsCompleted(true);
	}
	// Deferred API
	const deferredAPICalls = async () => {
		if (storePersist.get('guestTokenMetadata').current?.success) {
			await dispatch(organizationUnits.list({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/organization-units/list`, entity: 'organizationUnits', jsonData: {} }))
			await dispatch(queryByStore.list({ url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/localization/query-by-store`, entity: 'queryByStores', jsonData: {} }))
			await dispatch(library.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/library/query-by-list`, entity: 'library' }))
			await dispatch(countries.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/countrys`, entity: 'countries' }))
			await dispatch(states.read({ url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/beta/stateprovinces`, entity: 'states' }))
			await dispatch(cmsSettings.list({ url: `https://cms.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/cms/query`, entity: 'cmsSettings', jsonData: {} }))
		}
		fetchLogo()
	}

	// app initialization
	useEffect(() => {
		(async () => {
			await getGuestToken();
			const tenantId = storePersist?.get("guestTokenMetadata")?.current?.result?.TokenMetadata?.TenantId;
			setTenantId(tenantId)
			generateIdValue()
		})();
	}, []);

	const generateUniqueId = () => {
		const randomPart = Math.random().toString(36).substr(2, 9); // Random part
		const timestampPart = Date.now().toString(36); // Timestamp part
		return `${randomPart}-${timestampPart}`;
	};

	const generateIdValue = () => {
		const newItem = {
			transaction_id: generateUniqueId(),
			message_id: generateUniqueId(),
		};
		setGenerateIds(newItem);
	};

	const fetchLogo = () => {

		const storeData = {
			logoDark: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
				return logo.Background === 'Light'
			}),
			logoLight: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Logos.filter((logo: any) => {
				return logo.Background === 'Dark'
			}),
			storeName: organizationLists?.result?.items[0]?.BrandMappings[0]?.Name,
			description: organizationLists?.result?.items[0]?.BrandMappings[0]?.Description,
			favicon: organizationLists?.result?.items[0]?.BrandMappings[0]?.Configurations?.Favicons[0]?.Url || '/assets/images/logo.png'
		}
		setLogo(storeData)
	}

	useEffect(() => {
		(async () => {
			if (tenantId) {
				switch (tenantId) {
					// case 108: //Tranze qa
					// case 144: //Tranze prod
					// 	console.log('reading agri card data from table')
					// 	await readCardsFromTableStorage(process.env.REACT_APP_AZURE_STORAGE_SAS_CONNECTION_STRING_AGRI,'RetailUCP' )
					// 	break;
					// case 97:  //DBS qa
					// case 130: //DBS prod
					// 	await readCardsFromTableStorage(process.env.REACT_APP_AZURE_STORAGE_SAS_CONNECTION_STRING_DBS)
					// 	break;
					// case 154: // CAUVERYCOLLEGE prod
					// 	await readCardsFromTableStorage(process.env.REACT_APP_AZURE_STORAGE_SAS_CONNECTION_STRING_CAUVERYCOLLEGE)
					// 	break;
					default:
						await mandatoryAPICalls();
				}

				deferredAPICalls();

			}
		})()
	}, [tenantId])


	const highLightContentHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_GALLERY2_HEADING') : null;

	const highLightContentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_GALLERY2') : null;

	const workContentHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION1_HEADING') : null;

	const workContentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION1') : null;

	const promiseContentHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION2_HEADING') : null;

	const promiseContentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SECTION2') : null;

	const partnerConentData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_PARTNER') : null;

	const sliderData: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_SLIDER') : null;

	const aboutUsHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_ABOUTUS') : null;

	const domesticCourierHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_DOMESTIC_COURIER_HEADING') : null;

	const domesticCourierContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_DOMESTIC_COURIER') : null;

	const internationalCourierHeading: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_INTERNATIONAL_COURIER_HEADING') : null;

	const internationalCourierContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_INTERNATIONAL_COURIER') : null;

	const copyRightsContent: any = storePersist?.get("websiteCards")?.current?.items ? getCardData(storePersist?.get("websiteCards")?.current?.items, 'ULIP_COPYRIGHTS') : null;

	const handleNavigate = (path: any) => {
		navigate(`${path}`)
	}
	const handleSubmit = (event: any) => {
		event?.preventDefault()
		const fromAddressData = _.split(searchedLocation?.description, ',');
		const toAddressData = _.split(searchedToLocation?.description, ',');

		dispatch(leads.create({
			url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads`, entity: 'leadCreate', jsonData: {
				"Records": [
					{
						Context: {
							transaction_id: generateIds?.transaction_id,
							message_id: generateIds?.message_id,
						},
						Message: {
							LeadInfo: {
								Name: leadValues?.Name,
								Email: leadValues?.Email,
								PhoneNumber: leadValues?.PhoneNumber,
								date: leadValues?.date,
								Description: '',
								IsExistingUser: leadValues?.IsExistingUser || false,
								LeadPayload: {
									weight: {
										unit: '',
										value: 0
									},
									dimensions: {
										length: {
											unit: '',
											value: 0
										},
										breadth: {
											unit: '',
											value: 0
										},
										height: {
											unit: '',
											value: 0
										}
									},
									category: '',
									value: {
										currency: 'INR',
										value: 0
									},
									dangerous_goods: false
								},
								start: {
									location: {
										gps: `${searchedLocation?.lat},${searchedLocation?.long}`,
										address: {
											name: searchedLocation?.name,
											building: searchedLocation?.description,
											locality: `${fromAddressData[0]},${fromAddressData[1]}`,
											city: searchedLocation?.name,
											state: fromAddressData[3],
											country: 'India',
											area_code: searchedLocation?.pincode,
										},
									},
								},

								end: {
									location: {
										gps: `${searchedToLocation?.lat},${searchedToLocation?.long}`,
										address: {
											name: searchedToLocation?.name,
											building: searchedToLocation?.description,
											locality: `${toAddressData[0]},${toAddressData[1]}`,
											city: searchedToLocation?.name,
											state: toAddressData[3],
											country: 'India',
											area_code: searchedToLocation?.pincode,
										},
									},
								},
							}
						}
					}
				]
			}
		})).then(() => {
			setSearchedLocation({
				name: '',
				lat: '',
				long: '',
				pincode: '',
				description: '',
			});
			setSearchedToLocation({
				name: '',
				lat: '',
				long: '',
				pincode: '',
				description: '',
			});
			setLeadValues({
				Name: '',
				Email: '',
				PhoneNumber: '',
				date: '',
				IsExistingUser: '',
			})
			dispatch(settings.set({
				quoteData: leadValues,
				searchedLocation,
				searchedToLocation,
			}))
			dispatch(settings.set({ getQuote: 'open' }))
		})


	}
	useEffect(() => {
		setColor(theme)



	}, [theme, width]);
	return (
		<>
			{/* {!isMandatoryApiCallsCompleted ? <PageLoader /> : */}
			<div>
				{width && width < 720 ? <div className={`max-h-screen  primary-${color}`}>
					<div className="h-full overflow-y-auto">
						<div className="flex flex-col justify-around items-center w-screen h-max mt-10 p-5">
							<div className="flex flex-col justify-between items-center w-full  p-5">
								<Carousel
									autoPlay
									infiniteLoop
									showStatus={false}
									showIndicators={false}
									showThumbs={false}>
									{sliderData?.map((banner: any) => (
										<div>
											<img src={banner?.src} className=" h-32" />
										</div>
									))}
								</Carousel>
								<div className={`w-full  flex justify-center items-start`}>
									<div className={`absolute w-full text-xl mt-60 italic inset-0 z-10 h-max flex items-start justify-start text-center px-5`}>
										<div className={`rounded-3xl p-3 px-4 shadow  border-x border-y `}>Meet the World Largest Leading Global Logistic</div>
									</div>
									<img src={require('./../../../assets/img/worldmap.png')} className="w-[300px] h-48 brightness-75	   " />
								</div>
							</div>
							<div className={`w-full m-5 justify-center item-center rounded-xl secondary-${color}`}>
								<div className=" w-full p-1 flex flex-col justify-center items-center rounded-xl">
									<div className=" uppercase font-bold">Instant Quote Calculator</div>
									<div className=" w-full px-3 font-bold space-y-2">
										<div className="flex flex-row ">
											<div className=" w-full text-xs flex flex-row justify-start items-center">
												<input
													type="checkbox"
													name={"from"}
													placeholder=""
													className={`px-2 teritary-${color} text-xs px-3`}
													onChange={(event) => {
														handleChange(
															event.target.checked,
															'IsExistingUser'
														)
													}}
													value={leadValues?.IsExistingUser}
												/>
												<div className="mx-2">Are You Already Register?</div>
											</div>
										</div>
										{!leadValues?.IsExistingUser ? <>
											<div className="flex flex-row space-x-2">
												<div className=" w-full">
													<label
														className="block text-xs font-bold mb-1"
														htmlFor="grid-password">
														Name
													</label>
													<div className="border-0  text-xs ">
														<input
															type="text"
															name={"Name"}
															placeholder="Enter the Full Name"
															className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
															onChange={(event) => {
																handleChange(
																	event.target.value,
																	'Name'
																);
															}}
															value={leadValues?.Name} />
													</div>
												</div>
											</div>
											<div className="flex flex-row space-x-2">
												<div className=" w-full">
													<label
														className="block text-xs font-bold mb-1"
														htmlFor="grid-password">
														Email
													</label>
													<div className="border-0   text-xs ">
														<input
															type="email"
															name={"Email"}
															placeholder="Enter the Email"
															className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
															onChange={(event) => {
																handleChange(
																	event.target.value,
																	'Email'
																);
															}}
															value={leadValues?.Email} />
													</div>
												</div>
												<div className=" w-full">
													<label
														className="block text-xs font-bold mb-1"
														htmlFor="grid-password">
														Mobile
													</label>
													<div className="border-0  text-xs ">
														<input
															type="number"
															name={"PhoneNumber"}
															placeholder="Enter the Phone Number"
															className={`w-full py-1  teritary-${color} bg-opacity-0 text-xs px-3`}
															onChange={(event) => {
																handleChange(
																	event.target.value,
																	'PhoneNumber'
																);
															}}
															value={leadValues?.PhoneNumber} />
													</div>
												</div>
											</div>
											<div className="flex flex-row space-x-2">
												<div className=" w-full">
													<label
														className="block text-xs font-bold mb-1"
														htmlFor="grid-password">
														From
													</label>
													<div className="border-0   text-xs ">
														<GoogleMapSearch
															setLocation={setSearchedLocation}
															location={searchedLocation}
															placeholder="From Address" />

													</div>
												</div>
											</div>
											<div className="flex flex-row space-x-2">
												<div className=" w-full">
													<label
														className="block text-xs font-bold mb-1"
														htmlFor="grid-password">
														To
													</label>
													<div className="border-0   text-xs ">
														<GoogleMapSearch
															setLocation={setSearchedToLocation}
															location={searchedToLocation}
															placeholder="To Address" />
													</div>
												</div>
											</div>
											<div className="flex flex-row space-x-2">
												<div className=" w-full">
													<label
														className="block text-xs font-bold mb-1"
														htmlFor="grid-password">
														Schedule Date
													</label>
													<div className="border-0   text-xs ">
														<input
															type="date"
															min={new Date().toISOString().split("T")[0]}
															name={"frodatem"}
															placeholder=""
															className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
															onChange={(event) => {
																handleChange(
																	event.target.value,
																	'date'
																);
															}}
															value={leadValues?.date} />
													</div>
												</div>
											</div></> :
											<>
												<div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Login with Email or PhoneNumber
														</label>
														<div className="border-0  text-xs ">
															<input
																type="text"
																name={"Email"}
																placeholder="Login with Email or PhoneNumber"
																className={`w-full py-1 teritary-${color} bg-opacity-0 text-xs px-3`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'Email'
																	);
																}}
																value={leadValues?.Email} />
														</div>
													</div>

												</div><div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															From
														</label>
														<div className="border-0   text-xs ">
															<GoogleMapSearch
																setSearchedLocation={setSearchedLocation}
																searchedLocation={searchedLocation}
																placeholder="From Address" />

														</div>
													</div>
												</div><div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label>
														<div className="border-0  bg-[#F3F4F6FF] text-xs ">
															<GoogleMapSearch
																setSearchedLocation={setSearchedToLocation}
																searchedLocation={searchedToLocation}
																placeholder="To Address" />
														</div>
													</div>
												</div><div className="flex flex-row space-x-2">
													<div className=" w-full">
														<label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Schedule Date
														</label>
														<div className="border-0  bg-[#F3F4F6FF] text-xs ">
															<input
																type="date"
																min={new Date().toISOString().split("T")[0]}
																name={"frodatem"}
																placeholder=""
																className="w-full py-1 bg-black bg-opacity-0 text-xs px-3"
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'date'
																	);
																}}
																value={leadValues?.date} />
														</div>
													</div>
												</div></>
										}

									</div>


									<div className={`primary-${color} px-5 rounded-3xl flex flex-row space-x-1 flex item-center justify-center mt-5 mb-2 `}>
										<div
											onClick={handleSubmit}
											className=" uppercase text-xs my-3 font-bold">
											Get Quote
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="w-full flex  items-center justify-around flex-col h-max  border-y border-black border-opacity-20">
							<div className={`secondary-${color} w-full py-5 flex flex-col justify-around items-center`}>
								<div className="">
									<svg version="1.1" id="layer" fill={primary} xmlns="http://www.w3.org/2000/svg"
										width="100" height="100" viewBox="0 0 612 612.001"
									>
										<path d="M305.058,329.286V570.82l192.293-36.491V416.644c0-4.926,4.291-8.752,9.185-8.19l23.658,3.661
c4.162,0.478,7.305,4.001,7.305,8.19v136.717c0,3.885-2.713,7.243-6.512,8.061l-210.5,45.261
c-10.172,2.188-20.691,2.211-30.873,0.069L81.373,566.609c-3.738-0.786-6.446-4.037-6.545-7.854L71.23,419.907
c-0.112-4.354,3.181-8.046,7.521-8.427l176.886-15.543c3.068-0.269,5.73-2.226,6.902-5.074l26.648-64.716
C292.628,317.796,305.058,320.254,305.058,329.286z M69.23,250.204L13.721,368.855c-2.713,5.798,1.928,12.34,8.297,11.697
l208.464-21.064c2.946-0.298,5.505-2.152,6.707-4.858l67.075-151.111l-229.056,42.07C72.587,246.071,70.36,247.79,69.23,250.204z
M304.264,203.518l70.976,155.837c1.24,2.723,3.859,4.561,6.842,4.801l208.069,16.732c6.271,0.505,10.773-5.916,8.163-11.64
L544.05,250.284c-1.122-2.46-3.38-4.213-6.041-4.692L304.264,203.518z M245.942,80.473l51.515,89.207
c3.967,6.869,13.882,6.868,17.848,0l51.504-89.207c3.967-6.87-0.991-15.457-8.923-15.457h-25.748v-54.71
C332.138,4.614,327.525,0,321.833,0h-30.914c-5.691,0-10.305,4.614-10.305,10.305v54.71h-25.749
C246.933,65.015,241.975,73.603,245.942,80.473z"/>
									</svg>
								</div>
								<div className="flex flex-col justify-center items-center">
									<div className={`p-2 flex flex-col justify-center items-center space-y-1 py-2 `}>
										<div className="uppercase font-bold">Track Your Order</div>
										<div className=" text-[10px]">Enter tracking number and get traking result</div>
									</div>
									<div className={`flex flex-row bg-opacity-10  teritary-${color}  rounded-3xl item-center justify-center my-3`}>
										<input
											type="type"
											name={"from"}
											placeholder=""
											className="w-max bg-transparent p-1  text-xs px-5"
											onChange={(e) => console.log('')}
											value={""}
										/>
										<div className={`w-max secondary-${color}  px-5 rounded-3xl flex flex-row  item-center justify-center`}>
											<a className="hover:text-[#FFB934] uppercase text-xs my-3 font-bold" href="#">Track Order</a>
										</div>
									</div>
								</div>
								<div className="">
									<svg className="my-3" version="1.1" fill={primary} id="layer" width="100" height="100" viewBox="0 0 612 612">
										<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
C565.257,281.569,563.532,285.839,560.084,285.839z"/>
									</svg>
								</div>
							</div>
						</div>
						<div className={`w-screen flex items-center justify-center flex-col my-10 secondary-${color}`}>
							<div className="uppercase font-bold text-xl">{highLightContentHeading ? highLightContentHeading[0]?.title : null}</div>
							<div className="flex flex-col item-center justify-center">
								<div className={`flex flex-col justify-around py-5 items-center secondary-${color} `}>
									<svg id="layer" fill={primary} height="100" width="100" version="1.1" viewBox="0 0 298.994 298.994">
										<circle cx="49.774" cy="46.77" r="20.242" />
										<path d="M75.908,73.465c-6.511,0-45.899,0-52.434,0c-12.681,0-23.05,10.317-23.113,22.998L0,168.216
	c-0.027,5.394,4.324,9.789,9.718,9.816c0.017,0,0.033,0,0.05,0c5.371,0,9.739-4.341,9.766-9.718l0.361-71.755
	c0.005-1.04,0.851-1.879,1.891-1.877c1.04,0.003,1.881,0.846,1.881,1.886l0.005,164.177c0,6.473,5.247,11.72,11.72,11.72
	s11.72-5.247,11.72-11.72v-93.682h5.06v93.682c0,6.473,5.247,11.72,11.72,11.72s11.72-5.247,11.72-11.72
	c0-85.478-0.207-81.226-0.213-164.275c0-1.129,0.915-2.045,2.044-2.045c1.129,0,2.044,0.915,2.045,2.044
	c0,0.029-0.001,0.058-0.001,0.088l0.361,71.754c0.027,5.377,4.394,9.718,9.766,9.718c0.016,0,0.034,0,0.05,0
	c5.394-0.027,9.745-4.422,9.718-9.816l-0.361-71.754C98.958,83.781,88.59,73.465,75.908,73.465z"/>
										<path d="M189.203,253.101c-0.957,6.189,3.284,11.983,9.474,12.94c6.204,0.957,11.985-3.296,12.94-9.474l6.243-40.366h-22.95
	L189.203,253.101z"/>
										<path d="M160.3,216.201h-22.95l6.243,40.366c0.866,5.602,5.695,9.609,11.193,9.609c7.003,0,12.278-6.238,11.221-13.075
	L160.3,216.201z"/>
										<path d="M177.646,100.806c10.824,0,19.586-8.77,19.586-19.586c0-10.816-8.768-19.586-19.586-19.586
	c-10.817,0-19.586,8.768-19.586,19.586C158.061,92.062,166.851,100.806,177.646,100.806z"/>
										<path d="M294.856,185.995h-4.984c2.753,0,4.984-2.231,4.984-4.984c0-16.186,0-22.665,0-30.01c0-2.753-2.231-4.984-4.984-4.984
	H283.4v-9.758c0-1.851-1.501-3.352-3.352-3.352h-22.459c-1.851,0-3.352,1.501-3.352,3.352v9.758h-6.471
	c-2.534,0-4.622,1.893-4.938,4.341c-0.072,0.556-0.046-1.395-0.046,30.653c0,2.753,2.231,4.984,4.984,4.984h-45.195v-11.876
	l27.674-12.19c4.661-2.053,6.857-7.431,4.964-12.16c-2.385-5.97-8.35-19.569-13.703-30.575
	c-3.587-7.378-11.208-12.145-19.414-12.145c-22.081,0-27.606,0-51.844,0c-2.137,0-4.209,0.723-5.881,2.053l-28.165,22.394
	c-1.716,1.365-2.905,3.284-3.361,5.428l-7.806,36.638c-1.245,5.844,3.203,11.421,9.252,11.421c4.453,0,8.307-3.137,9.233-7.483
	l7.099-33.321l21.896-17.41v59.225h-45.252c-2.285,0-4.138,1.853-4.138,4.138v14.96c0,2.285,1.853,4.138,4.138,4.138h4.583v6.971
	v52.127c0,2.285,1.852,4.138,4.138,4.138h14.959c2.285,0,4.138-1.853,4.138-4.138v-52.127v-6.971h130.972v6.971v52.127
	c0,2.285,1.853,4.138,4.138,4.138h14.959c2.285,0,4.138-1.853,4.138-4.138v-52.127v-6.971h5.565c2.285,0,4.137-1.851,4.138-4.136
	c0-0.001,0-0.001,0-0.003v-14.96c0.001,0.001,0.001-0.001,0.001-0.001C298.992,187.846,297.14,185.995,294.856,185.995z
	 M202.571,127.907c0-0.475,0.328-0.888,0.792-0.995c0.464-0.107,0.939,0.12,1.147,0.548c3.23,6.641,6.822,14.545,9.598,20.924
	l-11.537,5.082V127.907z M276.696,146.016h-15.755v-6.406h15.755V146.016z"/>
									</svg>
									<div className="text-sm font-bold">{highLightContentData ? highLightContentData[0]?.title : null} {highLightContentData ? highLightContentData[0]?.subTitle : null}</div>
								</div>
								<div className={`flex flex-col justify-around py-5 items-center secondary-${color} rounded`}>
									<svg width="100" height="100"
										viewBox="0 0 24 24" id="layer" fill="none" >
										<path d="M22 12C22 13.3132 21.7413 14.6136 21.2388 15.8268C20.7362 17.0401 19.9997 18.1425 19.0711 19.0711C18.1425 19.9997 17.0401 20.7362 15.8268 21.2388C14.6136 21.7413 13.3132 22 12 22C10.6868 22 9.38642 21.7413 8.17317 21.2388C6.95991 20.7362 5.85752 19.9997 4.92893 19.0711C4.00035 18.1425 3.26375 17.0401 2.7612 15.8268C2.25866 14.6136 2 13.3132 2 12C2 10.6868 2.25866 9.38642 2.76121 8.17316C3.26375 6.95991 4.00035 5.85752 4.92893 4.92893C5.85752 4.00035 6.95991 3.26375 8.17317 2.7612C9.38642 2.25866 10.6868 2 12 2C13.3132 2 14.6136 2.25866 15.8268 2.76121C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12L22 12Z" stroke={primary} stroke-width="1.5" />
										<path d="M16 12C16 13.3132 15.8965 14.6136 15.6955 15.8268C15.4945 17.0401 15.1999 18.1425 14.8284 19.0711C14.457 19.9997 14.016 20.7362 13.5307 21.2388C13.0454 21.7413 12.5253 22 12 22C11.4747 22 10.9546 21.7413 10.4693 21.2388C9.98396 20.7362 9.54301 19.9997 9.17157 19.0711C8.80014 18.1425 8.5055 17.0401 8.30448 15.8268C8.10346 14.6136 8 13.3132 8 12C8 10.6868 8.10346 9.38642 8.30448 8.17316C8.5055 6.95991 8.80014 5.85752 9.17157 4.92893C9.54301 4.00035 9.98396 3.26375 10.4693 2.7612C10.9546 2.25866 11.4747 2 12 2C12.5253 2 13.0454 2.25866 13.5307 2.76121C14.016 3.26375 14.457 4.00035 14.8284 4.92893C15.1999 5.85752 15.4945 6.95991 15.6955 8.17317C15.8965 9.38642 16 10.6868 16 12L16 12Z" stroke={primary} stroke-width="1.5" />
										<path d="M2 12H22" stroke={primary} stroke-width="1.5" stroke-linecap="round" />
									</svg>
									<div className="text-sm font-bold">{highLightContentData ? highLightContentData[1]?.title : null} {highLightContentData ? highLightContentData[1]?.subTitle : null}</div>
								</div>
								<div className={`flex flex-col justify-around py-5 items-center secondary-${color} rounded`}>
									<svg width="100" height="100" fill="none" viewBox="0 0 24 24" id="layer" >
										<path d="M7.2998 5H22L20 12H8.37675M21 16H9L7 3H4M4 8H2M5 11H2M6 14H2M10 20C10 20.5523 9.55228 21 9 21C8.44772 21 8 20.5523 8 20C8 19.4477 8.44772 19 9 19C9.55228 19 10 19.4477 10 20ZM21 20C21 20.5523 20.5523 21 20 21C19.4477 21 19 20.5523 19 20C19 19.4477 19.4477 19 20 19C20.5523 19 21 19.4477 21 20Z" stroke={primary} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
									</svg>
									<div className="text-sm font-bold">{highLightContentData ? highLightContentData[2]?.title : null} {highLightContentData ? highLightContentData[2]?.subTitle : null}</div>
								</div>
								<div className={`flex flex-col justify-around py-5 items-center secondary-${color} rounded`}>
									<svg fill={primary} version="1.1" id="Capa_1" width="100" height="100" viewBox="0 0 612 612">
										<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
C565.257,281.569,563.532,285.839,560.084,285.839z"/>
									</svg>
									<div className="text-sm font-bold">{highLightContentData ? highLightContentData[3]?.title : null} {highLightContentData ? highLightContentData[3]?.subTitle : null}</div>
								</div>
							</div>
						</div>
						<div className="w-full flex items-center justify-center flex-col h-max   border-y border-black border-opacity-20">
							<div className={`flex flex-col justify-center items-center w-full  secondary-${color}`}>
								<div className="flex flex-col justify-center items-center my-10">
									<div className="uppercase font-bold ">{promiseContentHeading ? promiseContentHeading[0]?.title : null}</div>
								</div>
								<div className="flex flex-col justify-center item-center space-y-5 my-5">
									<div className={`w-[250px]  flex flex-col h-max items-center justify-center py-3  primary-${color} shadow-xl rounded-xl`}>
										<div>
											<svg fill={secondary} height="100" width="100" version="1.1" id="Capa_1" viewBox="0 0 490 490">
												<path d="M232.582,75.479c-93.474,0-169.521,76.049-169.521,169.521c0,93.474,76.047,169.519,169.521,169.519
c93.473,0,169.519-76.046,169.519-169.519C402.101,151.527,326.055,75.479,232.582,75.479z M364.829,302.657
c-12.73,5.033-26.869,9.256-42.051,12.604c2.236-18.367,3.585-37.736,3.988-57.643h49.541
C374.925,273.502,370.957,288.655,364.829,302.657z M88.856,257.618h49.539c0.402,19.902,1.751,39.266,3.986,57.628
c-15.183-3.348-29.322-7.565-42.047-12.588C94.206,288.656,90.239,273.502,88.856,257.618z M100.336,187.338
c12.735-5.034,26.876-9.257,42.064-12.605c-2.242,18.391-3.6,37.768-4.004,57.648h-49.54
C90.239,216.496,94.206,201.342,100.336,187.338z M245.2,165.671c17.799,0.471,35.1,1.936,51.528,4.33
c2.714,19.603,4.341,40.617,4.797,62.38H245.2V165.671z M245.2,140.428v-39.154c13.385,1.165,26.252,4.165,38.35,8.748
c3.367,10.412,6.296,21.787,8.762,33.925C277.116,142.021,261.329,140.836,245.2,140.428z M219.964,140.428
c-16.125,0.407-31.905,1.592-47.097,3.516c2.464-12.141,5.39-23.516,8.751-33.924c12.097-4.582,24.963-7.581,38.346-8.746V140.428z
M219.964,165.671l0.001,66.71h-56.327c0.457-21.728,2.092-42.752,4.813-62.384C184.876,167.605,202.169,166.141,219.964,165.671z
M163.637,257.618h56.328l0.001,66.711c-17.771-0.473-35.082-1.938-51.535-4.341C165.718,300.389,164.092,279.378,163.637,257.618z
M219.966,349.57v39.155c-13.387-1.165-26.254-4.165-38.352-8.749c-3.369-10.415-6.3-21.795-8.767-33.938
C188.061,347.971,203.854,349.162,219.966,349.57z M245.202,349.571c16.129-0.407,31.914-1.593,47.11-3.519
c-2.466,12.137-5.396,23.512-8.761,33.924c-12.098,4.584-24.965,7.583-38.35,8.749V349.571z M245.202,324.329l-0.002-66.711h56.325
c-0.456,21.763-2.081,42.778-4.797,62.382C280.3,322.395,263.001,323.858,245.202,324.329z M326.767,232.381
c-0.403-19.907-1.752-39.276-3.988-57.644c15.182,3.349,29.319,7.571,42.051,12.604c6.128,14.003,10.096,29.156,11.478,45.039
H326.767z M344.57,154.136c-8.272-2.254-16.886-4.245-25.778-5.966c-1.368-7.613-2.9-14.988-4.595-22.084
C325.612,133.945,335.847,143.404,344.57,154.136z M150.977,126.078c-1.692,7.097-3.227,14.472-4.594,22.086
c-8.896,1.722-17.511,3.714-25.788,5.968C129.323,143.398,139.558,133.939,150.977,126.078z M120.589,335.857
c8.273,2.251,16.887,4.244,25.778,5.965c1.368,7.615,2.901,14.992,4.596,22.088C139.546,356.05,129.313,346.592,120.589,335.857z
M314.199,363.912c1.692-7.094,3.226-14.469,4.593-22.081c8.895-1.722,17.506-3.714,25.778-5.968
C335.847,346.596,325.614,356.053,314.199,363.912z"/>
												<path d="M489.36,233.99c-1.15-2.516-3.66-4.129-6.428-4.129h-17.951c-3.603-56.469-27.298-109.063-67.67-149.434
C353.353,36.468,294.906,12.26,232.74,12.26S112.128,36.468,68.169,80.428C24.209,124.387,0,182.833,0,245
c0,62.166,24.209,120.611,68.169,164.571c43.959,43.96,102.404,68.169,164.571,68.169c52.738,0,104.401-18.133,145.472-51.055
c5.439-4.359,6.313-12.301,1.953-17.738c-4.357-5.436-12.297-6.312-17.737-1.953c-37.14,29.773-81.986,45.51-129.688,45.51
c-114.417,0-207.504-93.087-207.504-207.504c0-114.418,93.087-207.504,207.504-207.504c109.327,0,199.169,84.988,206.948,192.365
h-16.896c-2.764,0-5.277,1.613-6.427,4.129c-1.149,2.515-0.726,5.47,1.084,7.562l30.068,34.746
c1.342,1.552,3.292,2.442,5.343,2.442c2.053,0,4.001-0.891,5.344-2.441l30.072-34.746
C490.086,239.461,490.511,236.505,489.36,233.99z"/>
											</svg>
										</div>
										<div className="w-[200px] font-semibold text-sm text-center px-3 py-3 ">{promiseContentData ? promiseContentData[0]?.title : null} </div>
										<div className="w-[250px] text-xs main text-center px-3 rounded min-h-12">{promiseContentData ? promiseContentData[0]?.subTitle : null}</div>
									</div>
									<div className={`w-[250px] flex flex-col items-center justify-center py-3 primary-${color}  shadow-xl rounded-xl`}>
										<div className="">
											<svg fill={secondary} width="100" height="100" viewBox="0 0 50 50">
												<path d="M4 1C3.447 1 3 1.448 3 2L3 10C3 10.553 3.447 11 4 11L15 11C15.553 11 16 10.553 16 10L16 2C16 1.448 15.553 1 15 1L4 1 z M 37.164062 9.5C35.289759 9.5 33.707216 10.100433 32.857422 11L27 11 A 1.0001 1.0001 0 1 0 27 13L32.259766 13C32.645045 14.435874 34.65739 15.5 37.164062 15.5C38.270063 15.5 38.997172 15.287031 39.451172 14.832031C40.016172 14.264031 40.014719 13.463453 40.011719 12.689453L40.009766 12.498047L40.011719 12.308594C40.014719 11.535594 40.017172 10.735969 39.451172 10.167969C38.997172 9.7119687 38.272922 9.5 37.169922 9.5L37.164062 9.5 z M 2 13C1.447 13 1 13.448 1 14L1 22C1 22.552 1.447 23 2 23L11.015625 23C11.141625 21.347 12.102 19.217484 14 19.021484L14 14C14 13.448 13.553 13 13 13L2 13 z M 33.248047 16.685547C34.111047 23.246547 32.823125 29.604359 29.828125 33.193359C28.272125 35.056359 26.401578 36 24.267578 36C23.280578 36 22.695906 35.350687 22.378906 34.804688C21.522906 33.329687 21.375734 30.4365 23.302734 26.5625C22.012734 26.8515 20.394547 27 18.435547 27C17.257114 27 14.548266 26.991755 12.748047 26.035156C12.564418 25.937694 12.392472 25.829279 12.230469 25.710938C11.915435 25.480918 11.640065 25.214349 11.435547 24.894531C11.363467 24.927922 11.299313 24.965842 11.228516 25L1 25C0.447 25 0 25.448 0 26C0 26.553 0.447 27 1 27L8.140625 27C5.1303891 29.545041 4.0970005 32.516944 4.0371094 32.726562C3.9621094 32.992562 3.9995781 33.278625 4.1425781 33.515625C4.2855781 33.752625 4.5190625 33.920516 4.7890625 33.978516L19.869141 38L31.058594 38C31.023594 37.69 31 37.362 31 37C31 31.673 36.14 27 42 27C42.181 27 42.352391 27.009578 42.525391 27.017578C42.167391 23.010578 40.234813 19.650906 38.507812 17.378906C38.093812 17.451906 37.653062 17.5 37.164062 17.5C35.690063 17.5 34.351047 17.202547 33.248047 16.685547 z M 14.28125 21C14.184077 21 14.090938 21.029755 14 21.076172C13.998509 21.076936 13.997583 21.079303 13.996094 21.080078C13.882067 21.139256 13.775918 21.234863 13.675781 21.351562C13.662059 21.367468 13.648179 21.381642 13.634766 21.398438C13.535952 21.522709 13.444734 21.665208 13.365234 21.828125C13.265172 22.032233 13.18821 22.260101 13.126953 22.494141C13.107622 22.56791 13.098893 22.636507 13.083984 22.710938C13.064878 22.805995 13.03673 22.899883 13.025391 22.994141C13.033791 22.993923 13.04048 22.988703 13.048828 22.988281C13.033436 23.115491 13 23.246564 13 23.367188C13 24.385188 14.858547 25 18.435547 25C22.014547 25 25 24.386188 25 23.367188C25 22.350188 24.426797 21 23.716797 21L14.28125 21 z M 42 29C37.475 29 33 32.574 33 37C33 39.74 34.19 40 35 40C36.659 40 36 36.598 40 35C41.175 34.531 42.330391 34.384766 43.400391 34.384766C45.209391 34.384766 46.774109 34.804688 47.787109 34.804688C48.552109 34.804688 49.001953 34.564703 49.001953 33.720703C49.000953 32.999703 47.704 29 42 29 z M 43.179688 36.392578C42.282688 36.414578 41.479187 36.563422 40.742188 36.857422C40.554187 36.932422 40.385562 37.012703 40.226562 37.095703C40.087562 37.369703 40 37.673 40 38C40 39.103 40.897 40 42 40C43.103 40 44 39.103 44 38C44 37.339 43.674687 36.756578 43.179688 36.392578 z M 6.1933594 36.421875C6.0743594 36.937875 6 37.465 6 38C6 41.859 9.141 45 13 45C16.172 45 18.853938 42.876516 19.710938 39.978516C19.590938 39.969516 19.470516 39.964594 19.353516 39.933594L16.78125 39.246094C16.25425 40.839094 14.768 42 13 42C10.794 42 9 40.206 9 38C9 37.723 9.0348437 37.454359 9.0898438 37.193359L6.1933594 36.421875 z M 45.732422 36.59375C45.898422 37.03375 46 37.504 46 38C46 40.206 44.206 42 42 42C40.262 42 38.795141 40.880125 38.244141 39.328125C38.220141 39.376125 38.196828 39.424656 38.173828 39.472656C37.816828 40.207656 37.264 41.317297 36.125 41.779297C37.384 43.731297 39.565 45 42 45C45.859 45 49 41.859 49 38C49 37.545 48.940516 37.096297 48.853516 36.654297C48.534516 36.742297 48.190156 36.804688 47.785156 36.804688C47.208156 36.804688 46.583875 36.715141 45.921875 36.619141C45.861875 36.610141 45.793422 36.60275 45.732422 36.59375 z M 11.029297 37.712891C11.015297 37.807891 11 37.902 11 38C11 39.103 11.897 40 13 40C13.843 40 14.562469 39.472422 14.855469 38.732422L11.029297 37.712891 z" />
											</svg>
										</div>
										<div className="w-[200px] font-semibold text-sm text-center px-3 py-3 ">{promiseContentData ? promiseContentData[1]?.title : null} </div>
										<div className="w-[250px] text-xs  main text-center px-3  rounded  min-h-12">{promiseContentData ? promiseContentData[1]?.subTitle : null}o</div>
									</div>
									<div className={`w-[250px] flex flex-col items-center justify-center primary-${color}  shadow-xl rounded-xl`}>
										<div>
											<svg width="100" height="100" viewBox="0 0 1024 1024" fill={secondary} className="icon" version="1.1"><path d="M107.19232 617.00096h562.14528v77.76256H260.36224c-12.19584-33.49504-44.34944-57.4976-82.0224-57.4976-37.10976 0-68.864 23.296-81.46944 56.02304a37.2224 37.2224 0 0 1-26.90048-35.74784v-3.30752a37.2224 37.2224 0 0 1 37.2224-37.23264z m133.20192 98.85696a65.024 65.024 0 0 1-64.95232 64.94208c-35.79904 0-64.94208-29.1328-64.94208-64.94208s29.14304-64.95232 64.94208-64.95232a65.024 65.024 0 0 1 64.95232 64.95232z m-19.8656 0a45.13792 45.13792 0 0 0-45.08672-45.08672c-24.86272 0-45.07648 20.23424-45.07648 45.08672s20.224 45.07648 45.07648 45.07648a45.11744 45.11744 0 0 0 45.08672-45.07648z m676.32128 0c0 35.80928-29.14304 64.94208-64.95232 64.94208s-64.94208-29.1328-64.94208-64.94208 29.1328-64.95232 64.94208-64.95232 64.95232 29.14304 64.95232 64.95232z m-19.85536 0c0-24.86272-20.23424-45.08672-45.08672-45.08672s-45.07648 20.23424-45.07648 45.08672 20.224 45.07648 45.07648 45.07648 45.08672-20.21376 45.08672-45.07648zM991.56992 529.3056v146.8416c0 6.85056-5.56032 12.41088-12.41088 12.41088h-64.88064c-13.74208-30.21824-44.17536-51.3024-79.48288-51.3024s-65.75104 21.08416-79.49312 51.3024h-43.776a12.41088 12.41088 0 0 1-12.41088-12.41088V381.22496c0-6.8608 5.56032-12.41088 12.41088-12.41088h163.38944c6.85056 0 17.27488 2.28352 24.82176 12.41088l91.83232 148.08064z m-57.9072-32.26624l-55.83872-92.66176c-4.31104-7.97696-9.61536-12.40064-28.54912-12.40064H747.9296c-6.85056 0-12.41088 5.55008-12.41088 12.40064v92.66176c0 6.8608 5.56032 12.41088 12.41088 12.41088h173.32224c6.85056 0 12.41088-5.55008 12.41088-12.41088z m48.384 141.04576a11.58144 11.58144 0 0 0-23.16288 0v21.93408a11.58144 11.58144 0 0 0 23.16288 0v-21.93408zM32.43008 594.78016h636.90752V243.2H32.43008v351.58016z" /></svg>
										</div>
										<div className="w-[200px] font-semibold text-sm text-center  px-3 ">{promiseContentData ? promiseContentData[2]?.title : null} </div>
										<div className="w-[250px] text-xs main text-center p-3 rounded min-h-12 ">{promiseContentData ? promiseContentData[2]?.subTitle : null}</div>
									</div>
									<div className={`w-[250px] flex flex-col items-center  primary-${color} justify-center shadow-xl rounded-xl`}>
										<div className="">
											<svg fill={secondary} height="100" width="100" version="1.1" id="Capa_1" viewBox="0 0 490 490">
												<circle cx="158.808" cy="191.789" r="14.446" />
												<path d="M449.228,91.881c-18.694,0-34.436,12.584-39.249,29.74h-18.343c-6.092,0-11.03,4.938-11.03,11.029
c0,6.094,4.938,11.031,11.03,11.031h18.343c4.813,17.156,20.555,29.74,39.249,29.74c22.517,0,40.772-18.252,40.772-40.771
C490,110.135,471.745,91.881,449.228,91.881z"/>
												<path d="M449.824,186.672c-10.619,0-20.052,5.064-26.027,12.904c-3.183,3.711-14.34,15.705-28.986,20.158
c-15.983,4.859-32.241-3.533-32.323-3.576c-6.941-3.764-15.609-1.188-19.372,5.748c-3.76,6.938-0.862,15.066,5.75,19.371
c13.889,9.039,41.815,9.578,54.258,5.797c5.011-1.523,9.69-3.568,13.992-5.881v69.73c0,10.506,4.957,19.846,12.653,25.83v127.914
c0,11.076,8.979,20.055,20.056,20.055c11.077,0,20.057-8.979,20.057-20.055V336.754c7.696-5.984,12.652-15.326,12.652-25.83
v-91.543C482.533,201.316,467.89,186.672,449.824,186.672z"/>
												<path d="M354.974,204.584c11.248,0,15.301,6.238,26.073,6.238c6.088,0,13.171-2.184,13.171-5.445v-23.178
c0-8.082-6.576-14.658-14.658-14.658h-42.08v19.133c0,1.385-1.122,2.506-2.507,2.506H322.96c-1.385,0-2.508-1.121-2.508-2.506
v-19.133h-42.079c-8.082,0-14.658,6.576-14.658,14.658v101.188c0,8.082,6.576,14.658,14.658,14.658H379.56
c8.082,0,14.658-6.576,14.658-14.658v-20.158c0-0.727-0.315-1.416-0.862-1.893c-0.547-0.475-1.271-0.648-1.992-0.59
c-47.621,3.824-69.433-21.543-58.5-43.002C337.056,209.516,345.739,204.584,354.974,204.584z"/>
												<path d="M256.081,348.221h-20.308V20.318c0-8.307-6.735-15.041-15.043-15.041H45.377c-8.307,0-15.041,6.734-15.041,15.041v327.902
H10.027C4.489,348.221,0,352.709,0,358.248v35.514c0,5.539,4.489,10.027,10.027,10.027h246.054c5.538,0,10.028-4.488,10.028-10.027
v-35.514C266.109,352.709,261.619,348.221,256.081,348.221z M60.42,35.361h145.269v312.855H60.42V35.361z"/>
											</svg>
										</div>
										<div className="w-[200px] font-semibold text-sm text-center px-3  ">{promiseContentData ? promiseContentData[3]?.title : null} </div>
										<div className="w-[250px] text-xs  main text-center p-3  rounded min-h-12">{promiseContentData ? promiseContentData[3]?.subTitle : null}</div>
									</div>
								</div>
							</div>
						</div>
						<div className={`w-full flex items-center py-5 justify-center flex-col h-max border-y secondary-${color} border-black border-opacity-20`}>
							<div className="flex flex-col justify-center items-center w-full">
								<div className="flex flex-col justify-center items-center mt-10 w-full">
									<div className=" uppercase font-bold my-5">{workContentHeading ? workContentHeading[0]?.title : null}</div>
								</div>
							</div>
							<div className="flex flex-col justify-center space-y-5">
								<div className={`flex justify-center  secondary-${color} flex-col items-center rounded shadow-xl w-64 h-56`}>
									<svg width="100" height="100" viewBox="0 0 512 512">
										<path fill={primary} d="M268.383 22.168l-55.918 84.482 29.717 3.733c-9.22 30.13-11.095 50.878-8.885 92.12 14.138-2.23 25.56-3.025 40.586 1.39-9.877-36.84-8.844-49.427-4.88-89.768l32.622 2.277-33.242-94.234zm218.482 2.21l-108.36 30.03 20.915 25.975c-49.512 31.019-80.331 55.548-104.74 123.164 13.201-.152 28.098 2.921 44.174 9.004 5.728-44.666 33.74-76.14 79.302-108.918l19.983 24.816 48.726-104.07zm-463.574 2.31L89.17 129.173l19.084-28.711c35.554 32.44 58.145 76.33 57.308 107.43 18.568-8.696 29.927-9.527 49.735-3.778-8.105-31.203-43.577-108.722-91.639-129.103l16.57-26.037L23.292 26.687zm276.117 214.667c-5.28.12-10.21 2.415-16.937 9.594l-6.565 6.969-6.812-6.72c-7.387-7.28-13.216-9.29-19.125-9.03-5.908.26-12.855 3.367-20.625 9.656l-6.217 5.03-5.906-5.374c-8.9-8.052-16.485-10.439-23.75-10.064-5.288.274-10.775 2.266-16.25 5.75l40.966 73.69c15.454 9.451 47.034 13.006 68.75 2.062l39.594-73.344c-7.51-3.062-14.26-6.202-20.094-7.406-2.112-.437-4.07-.756-5.968-.813-.354-.01-.71-.008-1.06 0zm-89.97 96.188v.002c-18.035 12.742-32.516 34.717-38.125 66.904-5.435 31.196 3.129 52.266 18.283 66.625 15.155 14.36 37.902 21.736 61 21.436 23.1-.3 46.136-8.31 61.625-22.936 15.49-14.627 24.249-35.425 19.281-65.187-5.137-30.757-18.4-52.148-35.19-65.094-28.482 15.056-64.095 11.856-86.875-1.75z" />
									</svg>
									<div className="text-sm font-bold  py-2">{workContentData ? workContentData[0]?.title : null}</div>
									<div className="text-xs  px-8 py-2 text-center">{workContentData ? workContentData[0]?.subTille : null}</div>
								</div>
								<div className={`flex justify-center secondary-${color} flex-col items-center  rounded shadow-xl  w-64 h-56`}>
									<svg width="100" height="100" viewBox="0 0 20 20">
										<path fill={primary} d="M2.84210526,3.86504044 L2.84210526,11.2988054 C2.84210526,15.3455734 6.0468039,18.6261272 10,18.6261272 C13.9531961,18.6261272 17.1578947,15.3455734 17.1578947,11.2988054 L17.1578947,3.86837364 L9.9567671,1.44685758 L2.84210526,3.86504044 Z M9.95451486,0 L18.5,2.87358183 L18.5,11.2988054 C18.5,16.1043425 14.6944204,20 10,20 C5.30557963,20 1.5,16.1043425 1.5,11.2988054 L1.5,2.87358183 L9.95451486,0 Z M14.3737014,6.48544473 C14.0967483,6.23334258 13.6725898,6.25880251 13.4263169,6.54231108 L13.4263169,6.54231108 L9.11047784,11.5106915 L6.32211371,8.42587388 C6.07040936,8.1474088 5.64584183,8.13054472 5.37381559,8.38820691 C5.10178936,8.6458691 5.08531523,9.08048613 5.33701959,9.35895121 L5.33701959,9.35895121 L8.62781212,12.9996145 C8.89702337,13.2974478 9.35842515,13.2927747 9.62182714,12.9895471 L9.62182714,12.9895471 L14.4292528,7.45525373 C14.6755257,7.17174516 14.6506545,6.73754688 14.3737014,6.48544473 Z" />
									</svg>
									<div className="text-sm font-bold py-2">{workContentData ? workContentData[1]?.title : null}</div>
									<div className="text-xs  px-8 py-2 text-center">{workContentData ? workContentData[1]?.subTille : null}</div>
								</div>
								<div className={`flex justify-center secondary-${color} flex-col items-center   rounded shadow-xl  w-64 h-56`}>
									<svg fill={primary} width="100" height="100" version="1.1" id="Layer_1" viewBox="0 0 496 496">
										<path d="M144,144H32v112h112V144z M128,240H48v-80h80V240z" />
										<path d="M272,144H160v112h112V144z M256,240h-80v-80h80V240z" />
										<path d="M144,272H32v112h112V272z M128,368H48v-80h80V368z" />
										<path d="M272,272H160v112h112V272z M256,368h-80v-80h80V368z" />
										<polygon points="80,224 96,224 96,208 112,208 112,192 96,192 96,176 80,176 80,192 64,192 64,208 80,208 			" />
										<rect x="192" y="192" width="48" height="16" />
										<polygon points="69.656,357.656 88,339.312 106.344,357.656 117.656,346.344 99.312,328 117.656,309.656 106.344,298.344 
	88,316.688 69.656,298.344 58.344,309.656 76.688,328 58.344,346.344 			"/>
										<rect x="192" y="304" width="48" height="16" />
										<rect x="192" y="336" width="48" height="16" />
										<rect x="256" y="80" width="16" height="16" />
										<rect x="32" y="80" width="208" height="16" />
										<path d="M464,432H53.784L0.456,464l53.328,32H464c17.648,0,32-14.352,32-32S481.648,432,464,432z M384,480H58.216l-26.672-16
	l26.672-16H384V480z M416,480h-16v-32h16V480z M464,480h-32v-32h32c8.816,0,16,7.176,16,16C480,472.824,472.816,480,464,480z"/>
										<path d="M304,48V0H0v416h304v-48h192V48H304z M288,400H16V128h272V400z M288,112H16V16h272V112z M480,352H304V64h176V352z" />
										<path d="M387.704,334.752l4.296,2.736l4.296-2.736C399.064,332.984,464,290.648,464,208S399.064,83.016,396.296,81.248
	L392,78.512l-4.296,2.736C384.936,83.016,320,125.352,320,208S384.936,332.984,387.704,334.752z M392.016,97.848
	c8.776,6.728,29,24.344,42.584,52.24C422.656,141.28,407.952,136,392,136c-15.912,0-30.584,5.248-42.512,14.016
	C363.08,122.224,383.256,104.592,392.016,97.848z M392,152c30.872,0,56,25.128,56,56s-25.128,56-56,56s-56-25.128-56-56
	S361.128,152,392,152z M392,280c15.912,0,30.576-5.248,42.512-14.016c-13.6,27.792-33.776,45.424-42.528,52.168
	c-8.776-6.728-29-24.344-42.584-52.24C361.344,274.72,376.048,280,392,280z"/>
										<polygon points="384,248 400,248 400,216 432,216 432,200 400,200 400,168 384,168 384,200 352,200 352,216 384,216 			" />
									</svg>
									<div className="text-sm font-bold py-2">{workContentData ? workContentData[2]?.title : null}</div>
									<div className="text-xs px-8 py-2 text-center">{workContentData ? workContentData[2]?.subTille : null}</div>
								</div>
							</div>
						</div>
						<div className={`w-full flex flex-col items-center py-5  secondary-${color}  border-y border-black border-opacity-20`}>
							<div className="flex flex-col w-full text-md px-5">
								<div className="text-2xl font-bold py-3 uppercase">{partnerConentData ? partnerConentData[0]?.title : null}</div>
								<div className="text-md text-justify">{partnerConentData ? partnerConentData[0]?.description : null}
								</div>
							</div>
							<div className="flex w-full justify-center items-center p-2">
								{partnerConentData && partnerConentData[0]?.src ? <img src={partnerConentData[0]?.src} width="600" height="300" />
									: <img src={'https://via.placeholder.com/1000x337'} width="600" height="300" />}
							</div>
						</div>
						<div className={`flex flex-col w-full primary-${color} `}>
							<div className="flex flex-col space-y-5 p-10 w-scre en">
								<div className={`w-full italic text-2xl  terirary-${color}`} >
									<div className="border-0"><img src={logo?.logoDark[0]?.Url} className=" w-24" /></div>
									<div className="text-sm  text-justify">{aboutUsHeading ? aboutUsHeading[0]?.shortDescription : null}</div>
								</div>
								<div className={`w-full terirary-${color}  uppercase flex flex-col justify-center item-center text-sm`}>
									<div>Get to Know Us</div>
									<div className="text-[10px] space-y-2 pl-5 py-2">
										<div onClick={() => handleNavigate('/about-us')}> About Us</div>
										<div> Contact Us</div>
									</div>
								</div>
								<div className={`w-full terirary-${color}  uppercase flex flex-col justify-center item-center text-sm`}>
									<div>Platforms</div>
									<div className="text-[10px] space-y-2 pl-5 py-2">
										<div onClick={() => handleNavigate('/auth/login/transporter')}> Transporter Login</div>
										<div onClick={() => handleNavigate('/auth/login/transport-agent')}> Transport Agent Login</div>
										<div onClick={() => handleNavigate('/auth/login/management')}> Management Login</div>
									</div>
								</div>

								<div className={`w-full terirary-${color} uppercase flex flex-col justify-center item-center text-sm`}>
									<div>{domesticCourierHeading ? domesticCourierHeading[0]?.title : null}</div>
									{domesticCourierContent ? <div className="text-[10px] space-y-2 pl-5 py-2">
										{domesticCourierContent.map((content: any) =>

											<div>{content?.title}</div>
										)}

										<div> ...</div>
									</div> : null}
								</div>
								<div className={`w-full terirary-${color} uppercase flex flex-col justify-center item-center text-sm`}>
									<div>{internationalCourierHeading ? internationalCourierHeading[0]?.title : null}</div>
									{internationalCourierContent ? <div className="text-[10px] space-y-2 pl-5 py-2">
										{internationalCourierContent.map((content: any) =>

											<div>{content?.title}</div>
										)}
									</div> : null}
								</div>
								<div className={`w-full terirary-${color}  uppercase flex flex-col justify-center item-center text-sm`}>
									<div>Help</div>
									<div className="text-[10px] space-y-2 pl-5 py-2">
										<div> Track</div>
									</div>
								</div>
							</div>
							<div className={`w-screen  flex flex-col  px-8 py-6 justify-between items-end  bottom-0 secondary-${color} `}>
								<p className="mb-2 mb-0 text-xs">{copyRightsContent ? copyRightsContent[0].title : null}</p>
								<div className="flex">
									<a href="/customer/terms-of-use" className="mr-3  text-xs">Terms of Service &nbsp;&nbsp; |</a>
									<a href="/customer/privacy-policy" className="mr-3 text-xs">Privacy Policy &nbsp;&nbsp; |</a>
									<a href="/about-us" className=" text-xs">About Us</a>
								</div>
							</div>
						</div>
					</div>

				</div > :
					<div className={`flex flex-col items-center justify-center w-full`} >
						<GetQuote />
						{/* Banner Section */}
						<div className="flex flex-col items-center justify-center w-full" style={{ backgroundImage: `url(${banner})` }}>
							<div className="flex justify-around items-center p-1 w-full h-[620px] px-10">
								<div className="flex flex-col justify-between items-center w-1/2">
								</div>
								<div className={`w-1/3 justify-center item-center mt-48 rounded-2xl secondary-${color}`}>
									<div className="w-full p-5 flex flex-col justify-center items-center rounded-2xl">
										<div className="text-2xl  font-bold py-5">Instant Quote Calculator</div>
										<div className=" w-full px-3 font-bold space-y-2">
											<div className="flex flex-row ">
												<div className=" w-full text-xs flex flex-row justify-start items-center">
													<input
														type="checkbox"
														name={"from"}
														placeholder=""
														className={`px-2 teritary-${color} text-xs px-3`}
														onChange={(event) => {
															handleChange(
																event.target.checked,
																'IsExistingUser'
															)
														}}
														value={leadValues?.IsExistingUser}
													/>
													<div className="mx-2">Are You Already Register?</div>
												</div>
											</div>
											{!leadValues?.IsExistingUser ? <>
												<div className="flex flex-row space-x-2 ">
													<div className=" w-full pt-2">
														{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															From
														</label> */}
														<div className="font-normal ">
															<GoogleMapSearch
																setLocation={setSearchedLocation}
																location={searchedLocation}
																placeholder="Pickup Address" />

														</div>
													</div>
												</div>
												<div className="flex flex-row space-x-2 ">
													<div className=" w-full pt-4 ">
														{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															To
														</label> */}
														<div className=" font-normal ">
															<GoogleMapSearch
																setLocation={setSearchedToLocation}
																location={searchedToLocation}
																placeholder="Drop Address" />
														</div>
													</div>
												</div>

												<div className="flex flex-row space-x-2 ">
													<div className=" w-full">
														{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Mobile
														</label> */}
														<div className="border-0 font-normal">
															<input
																type="number"
																name={"PhoneNumber"}
																placeholder="Phone Number"
																className={`w-full py-3 px-3 border-b-2 border-black text-base `}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'PhoneNumber'
																	);
																}}
																value={leadValues?.PhoneNumber} />
														</div>
													</div>
													<div className=" w-full">
														{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Email
														</label> */}
														<div className="border-0   font-normal">
															<input
																type="email"
																name={"Email"}
																placeholder="Email"
																className={`w-full py-3 px-3 border-b-2 border-black text-base`}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'Email'
																	);
																}}
																value={leadValues?.Email} />
														</div>
													</div>

												</div>
												<div className="flex flex-row space-x-2 ">
													<div className=" w-full">
														{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Name
														</label> */}
														<div className="border-0 font-normal">
															<input
																type="text"
																name={"Name"}
																placeholder="Full Name"
																className={`w-full py-3 px-3 border-b-2 border-black text-base `}
																onChange={(event) => {
																	handleChange(
																		event.target.value,
																		'Name'
																	);
																}}
																value={leadValues?.Name} />
														</div>
													</div>
													<div className=" w-full">
														{/* <label
															className="block text-xs font-bold mb-1"
															htmlFor="grid-password">
															Schedule Date
														</label> */}
														<div className="border-0 font-normal ">

															<div className="relative w-full">
																{/* Label Placeholder */}
																<label
																	htmlFor="frodatem"
																	className={`absolute top-3 left-3 text-gray-400 pointer-events-none ${leadValues?.date ? 'hidden' : ''
																		}`}
																>
																	Schedule Date
																</label>

																<input
																	id="frodatem"
																	type="date"
																	min={new Date().toISOString().split("T")[0]}
																	name="frodatem"
																	className={`w-full py-3 border-b-2 border-black text-base px-3 ${!leadValues?.date ? 'text-transparent' : 'text-sky-950'
																		}`}
																	onChange={(event) => handleChange(event.target.value, 'date')}
																	value={leadValues?.date}
																/>
															</div>


														</div>
													</div>
												</div>

											</> :
												<>
													<div className="flex flex-row space-x-2">
														<div className=" w-full">
															{/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Login with Email or PhoneNumber
															</label> */}
															<div className="border-0  font-normal">
																<input
																	type="text"
																	name={"Email"}
																	placeholder="Login with Email or PhoneNumber"
																	className={`w-full py-3 px-3 border-b-2 border-black text-base`}
																	onChange={(event) => {
																		handleChange(
																			event.target.value,
																			'Email'
																		);
																	}}
																	value={leadValues?.Email} />
															</div>
														</div>

													</div><div className="flex flex-row space-x-2 ">
														<div className=" w-full pt-2">
															{/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																From
															</label> */}
															<div className="font-normal ">
																<GoogleMapSearch
																	setLocation={setSearchedLocation}
																	location={searchedLocation}
																	placeholder="Pickup Address" />
															</div>
														</div>
													</div><div className="flex flex-row space-x-2 ">
														<div className="w-full">
															{/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																To
															</label> */}
															<div className="font-normal pt-4 ">
																<GoogleMapSearch
																	setLocation={setSearchedToLocation}
																	location={searchedToLocation}
																	placeholder="Drop Address" />
															</div>
														</div>
													</div><div className="flex flex-row space-x-2">
														<div className=" w-full">
															{/* <label
																className="block text-xs font-bold mb-1"
																htmlFor="grid-password">
																Schedule Date
															</label> */}
															<div className="font-normal ">
																<div className="relative w-full">
																	{/* Label Placeholder */}
																	<label
																		htmlFor="frodatem"
																		className={`absolute top-3 left-3 text-gray-400 pointer-events-none ${leadValues?.date ? 'hidden' : ''
																			}`}
																	>
																		Schedule Date
																	</label>

																	<input
																		id="frodatem"
																		type="date"
																		min={new Date().toISOString().split("T")[0]}
																		name="frodatem"
																		className={`w-full py-3 px-3 border-b-2 border-black text-base ${!leadValues?.date ? 'text-transparent' : 'text-sky-950'
																			}`}
																		onChange={(event) => handleChange(event.target.value, 'date')}
																		value={leadValues?.date}
																	/>
																</div>

															</div>
														</div>
													</div></>
											}

										</div>
										{/* <div className="text-[#405578]  text-[9px] pt-3">Wrong weight and sized will seized ypur package + Rs500 penality</div> */}

										<div className={`primary-${color} px-5 flex w-full flex-row flex item-center justify-center mt-5 mb-10 `}>
											<div
												onClick={handleSubmit}
												className="text-base my-3 font-bold cursor-pointer">
												Get Quote
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>


						{/* <div className="w-full flex items-center justify-around flex-col h-max ">
								<div className={`secondary-${color} w-full py-5 flex flex-row justify-around items-center`}>
									<div className="">
										<svg fill={primary} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
											width="100" height="100" viewBox="0 0 612 612.001"
										>
											<path d="M305.058,329.286V570.82l192.293-36.491V416.644c0-4.926,4.291-8.752,9.185-8.19l23.658,3.661
		c4.162,0.478,7.305,4.001,7.305,8.19v136.717c0,3.885-2.713,7.243-6.512,8.061l-210.5,45.261
		c-10.172,2.188-20.691,2.211-30.873,0.069L81.373,566.609c-3.738-0.786-6.446-4.037-6.545-7.854L71.23,419.907
		c-0.112-4.354,3.181-8.046,7.521-8.427l176.886-15.543c3.068-0.269,5.73-2.226,6.902-5.074l26.648-64.716
		C292.628,317.796,305.058,320.254,305.058,329.286z M69.23,250.204L13.721,368.855c-2.713,5.798,1.928,12.34,8.297,11.697
		l208.464-21.064c2.946-0.298,5.505-2.152,6.707-4.858l67.075-151.111l-229.056,42.07C72.587,246.071,70.36,247.79,69.23,250.204z
		 M304.264,203.518l70.976,155.837c1.24,2.723,3.859,4.561,6.842,4.801l208.069,16.732c6.271,0.505,10.773-5.916,8.163-11.64
		L544.05,250.284c-1.122-2.46-3.38-4.213-6.041-4.692L304.264,203.518z M245.942,80.473l51.515,89.207
		c3.967,6.869,13.882,6.868,17.848,0l51.504-89.207c3.967-6.87-0.991-15.457-8.923-15.457h-25.748v-54.71
		C332.138,4.614,327.525,0,321.833,0h-30.914c-5.691,0-10.305,4.614-10.305,10.305v54.71h-25.749
		C246.933,65.015,241.975,73.603,245.942,80.473z"/>
										</svg>
									</div>
									<div className="flex flex-col justify-center items-center">
										<div className="p-2 flex flex-col justify-center items-center space-y-1 py-2">
											<div className="uppercase font-bold">Track Your Order</div>
											<div className="  text-[10px]">Enter tracking number and get traking result</div>
										</div>
										<div className={`flex flex-row bg-opacity-10  teritary-${color}  rounded-3xl item-center justify-center my-3`}>
											<input
												type="type"
												name={"from"}
												placeholder=" Enter the Tracking Number"
												className="w-64 bg-transparent p-1  text-xs px-5"
												onChange={(e) => console.log('')}
												value={""}
											/>
											<div className={`w-64 secondary-${color}  px-5 rounded-3xl flex flex-row  item-center justify-center`}>
												<a className=" hover:text-[#FFB934FF] uppercase text-xs my-3 font-bold" href="#">Track Order</a>
											</div>
										</div>
									</div>
									<div className="">
										<svg fill={primary} className="my-3" version="1.1" id="Capa_1" width="100" height="100" viewBox="0 0 612 612">
											<path d="M226.764,375.35c-28.249,0-51.078,22.91-51.078,51.16c0,28.166,22.829,51.078,51.078,51.078s51.078-22.912,51.078-51.078
			C277.841,398.26,255.013,375.35,226.764,375.35z M226.764,452.049c-14.125,0-25.54-11.498-25.54-25.541
			c0-14.123,11.415-25.539,25.54-25.539c14.124,0,25.539,11.416,25.539,25.539C252.302,440.551,240.888,452.049,226.764,452.049z
			 M612,337.561v54.541c0,13.605-11.029,24.635-24.636,24.635h-26.36c-4.763-32.684-32.929-57.812-66.927-57.812
			c-33.914,0-62.082,25.129-66.845,57.812H293.625c-4.763-32.684-32.93-57.812-66.845-57.812c-33.915,0-62.082,25.129-66.844,57.812
			h-33.012c-13.606,0-24.635-11.029-24.635-24.635v-54.541H612L612,337.561z M494.143,375.35c-28.249,0-51.16,22.91-51.16,51.16
			c0,28.166,22.912,51.078,51.16,51.078c28.166,0,51.077-22.912,51.077-51.078C545.22,398.26,522.309,375.35,494.143,375.35z
			 M494.143,452.049c-14.125,0-25.539-11.498-25.539-25.541c0-14.123,11.414-25.539,25.539-25.539
			c14.042,0,25.539,11.416,25.539,25.539C519.682,440.551,508.185,452.049,494.143,452.049z M602.293,282.637l-96.817-95.751
			c-6.159-6.077-14.453-9.526-23.076-9.526h-48.86v-18.313c0-13.631-11.004-24.635-24.635-24.635H126.907
			c-13.55,0-24.635,11.005-24.635,24.635v3.86L2.3,174.429l177.146,23.068L0,215.323l178.814,25.423L0,256.25l102.278,19.29
			l-0.007,48.403h509.712v-17.985C611.983,297.171,608.452,288.796,602.293,282.637z M560.084,285.839h-93.697
			c-2.135,0-3.86-1.724-3.86-3.859v-72.347c0-2.135,1.725-3.86,3.86-3.86h17.82c0.985,0,1.971,0.411,2.71,1.068l75.796,72.347
			C565.257,281.569,563.532,285.839,560.084,285.839z"/>
										</svg>
									</div>
								</div>
							</div> */}


						{/* Section 2 */}
						<div className="w-full flex items-center justify-center flex-col">
							<div className={`flex flex-col justify-center items-center w-full secondary-${color}`}>
								<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
									<div className="text-3xl font-bold ">
										{promiseContentHeading ? promiseContentHeading[0]?.title : null}
									</div>
								</div>
								<div className="flex flex-row justify-around items-stretch w-full my-10 mx-10">
									{/* Card 1 */}
									<div className="relative flex flex-col justify-center items-center w-72 px-2">
										<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
											<img src={'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
										</div>
										<div className="flex-grow p-1 font-semibold text-lg text-center">
											{promiseContentData ? promiseContentData[0]?.title : null}
										</div>
										<div className="flex-grow p-1 text-center text-base min-h-[60px]">
											{promiseContentData ? promiseContentData[0]?.subTitle : null}
										</div>
									</div>

									{/* Card 2 */}
									<div className="relative flex flex-col justify-center items-center w-72 px-2">
										<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
											<img src={'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
										</div>
										<div className="flex-grow p-1 font-semibold text-lg text-center">
											{promiseContentData ? promiseContentData[1]?.title : null}
										</div>
										<div className="flex-grow p-1 text-center text-base min-h-[60px]">
											{promiseContentData ? promiseContentData[1]?.subTitle : null}
										</div>
									</div>

									{/* Card 3 */}
									<div className="relative flex flex-col justify-center items-center w-72 px-2">
										<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
											<img src={'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
										</div>
										<div className="flex-grow p-1 font-semibold text-lg text-center">
											{promiseContentData ? promiseContentData[2]?.title : null}
										</div>
										<div className="flex-grow p-1 text-center text-base min-h-[60px]">
											{promiseContentData ? promiseContentData[2]?.subTitle : null}
										</div>
									</div>

									{/* Card 4 */}
									<div className="relative flex flex-col justify-center items-center w-72 px-2">
										<div className="relative overflow-hidden bg-clip-border rounded-xl h-64">
											<img src={'https://via.placeholder.com/272x256'} alt="card-image" className="object-cover w-full h-full" />
										</div>
										<div className="flex-grow p-1 font-semibold text-lg text-center">
											{promiseContentData ? promiseContentData[3]?.title : null}
										</div>
										<div className="flex-grow p-1 text-center text-base min-h-[60px]">
											{promiseContentData ? promiseContentData[3]?.subTitle : null}
										</div>
									</div>
								</div>
							</div>
						</div>

						{/* Section 3 */}
						<div className="w-full flex items-center justify-center flex-col">
							<div className={`flex flex-col justify-center items-center w-full secondary-${color}`}>
								<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
									<div className="text-3xl font-bold ">
										{highLightContentHeading ? highLightContentHeading[0]?.title : null}
									</div>
								</div>
								<div className="flex flex-row justify-around items-stretch w-full my-10 mx-10 ">
									{/* Card 1 */}
									<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 primary-${color}`}>
										<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
										<svg width="100" height="100" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" fill="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>go-green</title> <g id="Layer_2" data-name="Layer 2"> <g id="invisible_box" data-name="invisible box"> <rect width="48" height="48" fill="none"></rect> <rect width="48" height="48" fill="none"></rect> </g> <g id="icons_Q2" data-name="icons Q2"> <path d="M38.8,26.1c-5.9,4.2-16.2,2.6-16.2,5.7s.6,11.1.6,11.1L18.8,44s.6-9.5.6-12.2-7-1.1-10.8-3.1S3.7,16.6,4.2,14c3.3,2.6,5.4,2.6,9.8,4.2s6,5.6,6.7,8.2c0,.1-7.7-1.4-12.1-5.5C10,25,15,26.6,17.2,27.1A4.7,4.7,0,0,1,21,29.7c.5-2.1,5.3-6.8,9.1-8.4s7.6-4.2,8.2-7.1c-4.3,4-8.1,4.1-11.9,6.6a16.3,16.3,0,0,0-4.6,4.5c.6-2.8,2.3-9.6,5.7-12.9C34.1,6.1,38.3,8.7,43.7,4,44.2,5.6,44.8,21.9,38.8,26.1Z"></path> </g> </g> </g></svg>
										</div>
										<div className="flex-grow pt-4 font-semibold text-3xl">
											{highLightContentData ? highLightContentData[0]?.title : null} {highLightContentData ? highLightContentData[0]?.subTitle : null}
										</div>
										{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[0]?.subTitle : null}
                </div> */}
									</div>

									{/* Card 2 */}
									<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 primary-${color}`}>
										<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
										<svg fill="#ffffff" height="100" width="100"  viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M22,2V5H18V2ZM18,7h4V22H2V10L8,7v3l6-3v3h4ZM8,17H5v2H8Zm0-4H5v2H8Zm6,4H10v2h4Zm0-4H10v2h4Zm5,4H16v2h3Zm0-4H16v2h3Z"></path></g></svg>
										</div>
										<div className="flex-grow pt-4 font-semibold text-3xl">
											{highLightContentData ? highLightContentData[1]?.title : null} {highLightContentData ? highLightContentData[1]?.subTitle : null}
										</div>
										{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[1]?.subTitle : null}
                </div> */}
									</div>

									{/* Card 3 */}
									<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 primary-${color}`}>
										<div className="relative overflow-hidden bg-clip-border rounded-xl pt-14">
										<svg fill="#ffffff" height="100" width="100" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 463.01 463.01" stroke="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <path d="M236.234,300.093c6.524,0,11.451-2.283,15.063-6.979c3.716-4.83,5.6-11.241,5.6-19.055v-19.266 c0-7.662-1.905-13.996-5.664-18.825c-3.66-4.704-8.59-6.99-15.071-6.99c-6.465,0-11.315,2.265-14.829,6.923 c-3.629,4.812-5.469,11.168-5.469,18.893v19.266c0,7.819,1.863,14.234,5.537,19.066 C224.961,297.813,229.814,300.093,236.234,300.093z"></path> <path d="M400.444,220.561c3.321-10.508,5.001-21.422,5.001-32.523c0-59.535-48.435-107.97-107.969-107.97 c-36.11,0-70.11,18.412-90.006,48.394c-15.298-10.923-33.797-16.886-52.667-16.886c-49.978,0-90.638,40.66-90.638,90.639 c0,5.925,0.575,11.824,1.712,17.602C27.97,227.549,0,261.358,0,300.538c0,45.438,36.966,82.404,82.403,82.404h298.205 c45.437,0,82.402-36.967,82.402-82.404C463.01,262.331,437.021,229.555,400.444,220.561z M175.683,247.879l-0.835,2.513h-24.989 v-2.5c0-6.322-1.474-11.162-4.382-14.387c-2.841-3.149-7.485-4.746-13.804-4.746c-5.562,0-9.855,2.197-13.125,6.717 c-3.407,4.706-5.134,10.859-5.134,18.29v21.175c0,7.504,1.813,13.69,5.389,18.388c3.464,4.552,8.031,6.765,13.962,6.765 c5.876,0,10.211-1.52,12.883-4.518c2.745-3.08,4.137-7.876,4.137-14.251v-2.5H174.7l0.837,2.511l0.006,0.384 c0.205,12.095-3.578,21.863-11.244,29.035c-7.608,7.118-18.218,10.727-31.535,10.727c-13.415,0-24.482-4.396-32.896-13.068 c-8.395-8.648-12.651-19.895-12.651-33.425v-21.05c0-13.465,4.149-24.702,12.333-33.397c8.226-8.739,19.033-13.17,32.122-13.17 c13.69,0,24.598,3.613,32.42,10.74c7.9,7.199,11.801,17.086,11.596,29.386L175.683,247.879z M283.166,273.968 c0,13.624-4.391,25.065-13.051,34.006c-8.681,8.963-20.079,13.507-33.881,13.507c-13.709,0-25.025-4.547-33.633-13.515 c-8.582-8.939-12.934-20.378-12.934-33.998v-19.084c0-13.569,4.337-24.994,12.892-33.957c8.586-8.995,19.891-13.557,33.602-13.557 c13.799,0,25.211,4.557,33.918,13.544c8.684,8.966,13.087,20.395,13.087,33.97V273.968z M376.656,319.951h-77.4v-17.397 l34.979-37.503c4.75-5.45,8.195-10.133,10.185-13.857c1.883-3.525,2.837-6.793,2.837-9.712c0-3.893-0.986-6.95-3.014-9.348 c-1.923-2.271-4.646-3.375-8.325-3.375c-4.119,0-7.127,1.312-9.197,4.011c-2.193,2.863-3.307,6.824-3.307,11.771v2.5h-24.985 l-0.837-2.499l-0.01-0.375c-0.26-10.225,3.155-19.01,10.152-26.109c6.987-7.092,16.47-10.688,28.184-10.688 c11.517,0,20.745,3.087,27.431,9.174c6.753,6.149,10.177,14.417,10.177,24.573c0,6.871-1.912,13.297-5.685,19.099 c-3.583,5.511-9.539,12.79-17.704,21.638l-15.346,16.709h41.866V319.951z"></path> </g> </g></svg>
										</div>
										<div className="flex-grow pt-4 font-semibold text-3xl">
											{highLightContentData ? highLightContentData[2]?.title : null} {highLightContentData ? highLightContentData[2]?.subTitle : null}
										</div>
										{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[2]?.subTitle : null}
                </div> */}
									</div>

									{/* Card 4 */}
									<div className={`relative flex flex-col justify-center items-center rounded-xl h-72 w-72 px-2 primary-${color}`}>
										<div className="relative overflow-hidden bg-clip-border pt-14">
										<svg height="100" width="100" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#ffffff"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> </style> <g> <path  d="M255.988,181.426c7.456,0,14.499,1.71,20.747,4.765V17.334c0-9.579-5.3-17.334-14.142-17.334 c-12.829,0-20.073,12.853-23.266,30.544c-2.439,13.364-20.082,91.755-20.082,118.06c0,13.429,3.971,29.078,8.493,42.133 C235.648,184.887,245.421,181.426,255.988,181.426z"></path> <path d="M240.477,273.78c-16.58-5.722-28.989-20.35-31.492-38.162c-48.43,27.968-140.25,80.984-143.548,82.865 c-8.29,4.789-12.342,13.25-7.934,20.925c6.426,11.118,21.168,10.948,38.073,4.894c12.804-4.587,89.518-28.478,112.298-41.646 C219.666,295.856,231.417,284.348,240.477,273.78z"></path> <path d="M439.19,311.902c-10.373-8.801-69.436-63.277-92.216-76.422c-12.61-7.294-29.815-11.831-44.127-14.319 c0.422,2.504,0.641,5.097,0.641,7.739c0,15.179-7.115,28.705-18.194,37.344c47.498,27.416,143.24,82.711,146.612,84.663 c8.282,4.79,17.634,4.076,22.075-3.59C460.398,336.19,452.886,323.515,439.19,311.902z"></path> <path  d="M221.06,228.908c0,19.296,15.641,34.937,34.928,34.937c19.304,0,34.946-15.641,34.946-34.937 c0-19.295-15.641-34.928-34.946-34.928C236.701,193.98,221.06,209.612,221.06,228.908z M272.861,228.908 c0,9.32-7.552,16.865-16.873,16.865c-9.304,0-16.856-7.545-16.856-16.865c0-9.311,7.552-16.864,16.856-16.864 C265.309,212.043,272.861,219.596,272.861,228.908z"></path> <polygon points="284.013,293.376 232.827,293.376 220.639,470.507 203.45,470.507 203.45,512 217.786,512 299.743,512 314.079,512 314.079,470.507 296.753,470.507 "></polygon> </g> </g></svg>
										</div>
										<div className="flex-grow pt-4 font-semibold text-3xl">
											{highLightContentData ? highLightContentData[3]?.title : null} {highLightContentData ? highLightContentData[3]?.subTitle : null}
										</div>
										{/* <div className="flex-grow p-1 text-center text-xs min-h-[60px]">
                    {promiseContentData ? promiseContentData[3]?.subTitle : null}
                </div> */}
									</div>
								</div>
							</div>
						</div>

						<div className="w-full flex items-center justify-center flex-col">
							<div className={`flex flex-col justify-center items-center w-full secondary-${color}`}>
								<div className="flex flex-col justify-start pt-20 pl-14 items-start space-y-1 w-full pr-10">
									<div className="text-3xl font-bold ">
										{workContentHeading ? workContentHeading[0]?.title : null}
									</div>
								</div>
								<div className="flex flex-row justify-around items-stretch w-full my-10 mx-5 px-20">
									{/* Card 1 */}
									<div className="relative flex flex-col justify-center items-center w-80 ">
										<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
											<svg height="150" width="150" version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#233c64" transform="matrix(-1, 0, 0, 1, 0, 0)"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <style type="text/css"> </style> <g> <path d="M447.77,33.653c-36.385-5.566-70.629,15.824-82.588,49.228h-44.038v37.899h40.902 c5.212,31.372,29.694,57.355,62.855,62.436c41.278,6.316,79.882-22.042,86.222-63.341C517.428,78.575,489.07,39.969,447.77,33.653z "></path> <path d="M162.615,338.222c0-6.88-5.577-12.468-12.468-12.468H96.16c-6.891,0-12.467,5.588-12.467,12.468 c0,6.868,5.576,12.467,12.467,12.467h53.988C157.038,350.689,162.615,345.091,162.615,338.222z"></path> <path d="M392.999,237.965L284.273,340.452l-37.966,9.398v-86.619H0v215.996h246.307v-59.454l35.547-5.732 c16.95-2.418,29.396-6.692,44.336-15.018l46.302-24.228v104.432h132.435V270.828C504.927,202.618,428.016,202.43,392.999,237.965z M215.996,448.913H30.313v-155.37h185.683v63.805l-36.419,9.01c-15.968,4.395-25.708,20.518-22.174,36.696l0.298,1.247 c3.478,15.912,18.651,26.436,34.785,24.14l23.51-3.788V448.913z"></path> </g> </g></svg>
										</div>
										<div className="flex-grow p-1 font-semibold text-lg text-center">
											{workContentData ? workContentData[0]?.title : null}
										</div>
										<div className="flex-grow p-1 text-center text-base min-h-[60px]">
											{workContentData ? workContentData[0]?.subTille : null}
										</div>
									</div>
									<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
									{/* Card 2 */}
									<div className="relative flex flex-col justify-center items-center w-80 ">

										<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
											<svg fill="#233c64" height="150" width="150" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" stroke="#233c64"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <path d="M400.716,274.634h41.717c19.101,0,34.641-15.54,34.641-34.641V171.74c0-16.355-11.397-30.09-26.665-33.703 c-13.248-37.843-37.764-71.676-69.849-96.092C344.5,14.505,301.427,0,256.001,0s-88.498,14.505-124.559,41.945 c-32.086,24.416-56.602,58.248-69.851,96.092c-15.267,3.614-26.665,17.348-26.665,33.703v68.252 c0,19.101,15.54,34.641,34.641,34.641h41.717c8.929,18.717,21.384,35.439,36.502,49.305 c-60.017,0.265-108.762,49.166-108.762,109.244V512h433.952v-78.817c0-60.078-48.746-108.98-108.762-109.244 C379.331,310.072,391.786,293.349,400.716,274.634z M446.658,171.739v68.253c0,2.329-1.895,4.224-4.224,4.224h-26.192v-38.349 c0-0.013,0-0.025,0-0.039c0-1.328-0.017-2.652-0.05-3.992c0-0.01-0.001-0.02-0.001-0.03c-0.004-0.152-0.011-0.304-0.015-0.456 c-0.006-0.156-0.01-0.312-0.016-0.468l-0.026-0.722c-0.025-0.766-0.053-1.53-0.089-2.276c0-0.005-0.001-0.01-0.001-0.014 c-0.018-0.37-0.044-0.739-0.065-1.109c-0.003-0.046-0.005-0.091-0.008-0.137l-0.053-0.85c-0.037-0.622-0.075-1.242-0.122-1.882 c0-0.003,0-0.005-0.001-0.008c-0.041-0.546-0.091-1.091-0.137-1.636l-0.042-0.48c-0.048-0.561-0.096-1.121-0.151-1.68 c-0.065-0.666-0.14-1.329-0.214-1.993l-0.041-0.362c-0.043-0.385-0.088-0.771-0.134-1.157c-0.102-0.849-0.213-1.694-0.328-2.538 l-0.042-0.306c-0.069-0.502-0.138-1.004-0.211-1.492c-0.109-0.73-0.225-1.456-0.344-2.183c-0.08-0.496-0.16-0.984-0.24-1.449 c-0.635-3.688-1.398-7.332-2.28-10.929c-0.013-0.054-0.026-0.109-0.04-0.163h30.842 C444.763,167.515,446.658,169.41,446.658,171.739z M100.362,167.71c-0.924,3.766-1.712,7.582-2.364,11.445 c-0.043,0.259-0.087,0.516-0.129,0.775l-0.027,0.167c-0.39,2.402-0.725,4.822-1.007,7.26c-0.019,0.17-0.041,0.341-0.059,0.512 l-0.014,0.124c-0.074,0.66-0.15,1.32-0.215,1.982c0,0.002,0,0.004-0.001,0.007c-0.059,0.593-0.109,1.189-0.16,1.786l-0.04,0.464 c-0.05,0.593-0.103,1.185-0.147,1.779c-0.043,0.585-0.078,1.172-0.115,1.759l-0.053,0.86c0,0.008-0.001,0.016-0.001,0.023 c-0.024,0.428-0.053,0.856-0.074,1.285c-0.039,0.788-0.066,1.579-0.092,2.37l-0.018,0.489c-0.003,0.085-0.005,0.164-0.008,0.248 c-0.047,1.605-0.078,3.209-0.078,4.821v38.349H69.568c-2.329,0-4.224-1.895-4.224-4.224v-68.252c0-2.329,1.895-4.224,4.224-4.224 h30.842C100.394,167.58,100.379,167.646,100.362,167.71z M94.562,137.1c11.91-27.801,31.076-52.516,55.299-70.949 c30.72-23.378,67.423-35.734,106.14-35.734s75.419,12.356,106.141,35.734c24.223,18.433,43.388,43.148,55.298,70.949h-16.723 c-25.783-54.041-80.957-91.475-144.716-91.475S137.068,83.059,111.285,137.1H94.562z M365.942,136.902 c-18.028,12.356-39.456,19.077-61.526,19.077c-29.098,0-56.45-11.335-77.018-31.919l-10.013-10.021l-10.706,9.278 c-15.003,13.002-34.214,20.164-54.096,20.164c-3.379,0-6.737-0.207-10.06-0.61c22.196-39.825,64.74-66.827,113.478-66.827 C302.264,76.043,342.945,100.372,365.942,136.902z M442.56,433.183v48.4H69.442v-48.4c0-43.469,35.364-78.833,78.833-78.833 h35.241v3.828c0,39.968,32.516,72.484,72.484,72.484c39.968,0,72.484-32.516,72.484-72.484v-3.828h35.241 C407.196,354.35,442.56,389.714,442.56,433.183z M214,360.547c0.038,0.01,0.075,0.018,0.113,0.028 c1.48,0.401,2.968,0.774,4.459,1.132c0.442,0.106,0.886,0.208,1.329,0.31c1.192,0.275,2.388,0.536,3.587,0.784 c0.388,0.08,0.775,0.164,1.163,0.241c1.54,0.306,3.084,0.591,4.635,0.851c0.293,0.05,0.587,0.091,0.881,0.139 c1.285,0.208,2.572,0.401,3.864,0.577c0.461,0.063,0.924,0.125,1.386,0.183c1.306,0.167,2.616,0.318,3.928,0.454 c0.282,0.029,0.563,0.064,0.845,0.091c1.086,0.105,2.175,0.196,3.264,0.28c0.1,0.008,0.2,0.017,0.3,0.025 c0.386,0.029,0.774,0.057,1.161,0.083c0.407,0.027,0.813,0.049,1.221,0.073c0.369,0.022,0.738,0.047,1.108,0.066 c0.208,0.011,0.414,0.026,0.622,0.038c0.654,0.032,1.31,0.054,1.966,0.078c0.453,0.017,0.907,0.035,1.362,0.049 c0.253,0.007,0.505,0.02,0.758,0.026c1.347,0.033,2.698,0.052,4.052,0.052c1.354,0,2.704-0.018,4.052-0.052 c0.253-0.006,0.505-0.019,0.758-0.026c0.454-0.013,0.907-0.031,1.362-0.049c0.655-0.024,1.312-0.046,1.966-0.078 c0.208-0.01,0.414-0.026,0.622-0.038c0.37-0.02,0.739-0.044,1.108-0.066c0.407-0.024,0.814-0.045,1.221-0.073 c0.387-0.026,0.775-0.054,1.161-0.083c0.1-0.008,0.2-0.017,0.3-0.025c1.09-0.084,2.178-0.174,3.264-0.28 c0.282-0.027,0.563-0.063,0.845-0.091c1.312-0.135,2.622-0.287,3.928-0.454c0.462-0.059,0.925-0.121,1.386-0.183 c1.291-0.176,2.579-0.369,3.864-0.577c0.293-0.048,0.588-0.089,0.881-0.139c1.55-0.261,3.094-0.545,4.635-0.851 c0.388-0.077,0.776-0.161,1.163-0.241c1.198-0.247,2.395-0.508,3.587-0.784c0.443-0.102,0.887-0.204,1.329-0.31 c1.491-0.358,2.979-0.73,4.459-1.132c0.034-0.01,0.073-0.018,0.111-0.028c-1.231,22.099-19.599,39.698-42.001,39.698 S215.231,382.646,214,360.547z M295.658,275.305c-5.582-10.919-16.937-18.416-30.018-18.416h-19.28 c-18.581,0-33.697,15.117-33.697,33.698c0,18.582,15.116,33.698,33.697,33.698h19.28c13.14,0,24.54-7.565,30.094-18.564 l43.462-0.277c-22.546,18.868-51.565,30.244-83.195,30.244c-71.586,0.001-129.823-58.238-129.823-129.823 c0-1.087,0.014-2.17,0.043-3.28l0.047-1.279c0.021-0.647,0.042-1.293,0.073-1.924c0.014-0.275,0.031-0.549,0.049-0.822 l0.032-0.528c0.037-0.614,0.072-1.23,0.118-1.842c0-0.006,0.001-0.012,0.001-0.017c0.025-0.35,0.057-0.698,0.087-1.046 l0.056-0.641c0.045-0.513,0.086-1.028,0.137-1.54c0.042-0.409,0.087-0.815,0.133-1.223l0.04-0.356 c0.039-0.348,0.078-0.696,0.12-1.042c0.019-0.169,0.036-0.335,0.059-0.507c0.06-0.481,0.125-0.959,0.191-1.438l0.028-0.207 c0.01-0.078,0.022-0.157,0.032-0.235c0.059-0.427,0.117-0.855,0.18-1.281c0.079-0.525,0.163-1.047,0.243-1.545 c0.084-0.518,0.168-1.036,0.259-1.553c0.095-0.554,0.198-1.106,0.303-1.665c0.086-0.458,0.173-0.916,0.264-1.372 c0.112-0.568,0.23-1.136,0.354-1.718c0.093-0.438,0.189-0.875,0.286-1.312c0.132-0.593,0.269-1.185,0.409-1.769 c0.104-0.438,0.212-0.875,0.32-1.311c0.142-0.569,0.287-1.135,0.432-1.687c0.085-0.322,0.174-0.643,0.262-0.964 c7.166,1.406,14.47,2.135,21.85,2.135c22.63,0,44.63-6.784,63.208-19.313c24.895,20.604,55.898,31.812,88.625,31.812 c26.607,0,52.499-7.617,74.701-21.727c0.127,0.38,0.253,0.767,0.384,1.172l0.109,0.336c0.057,0.176,0.117,0.352,0.172,0.529 c0.192,0.602,0.375,1.208,0.557,1.812c0.114,0.378,0.228,0.757,0.339,1.137c0.177,0.61,0.35,1.225,0.52,1.847 c0.108,0.393,0.216,0.788,0.321,1.183c0.154,0.581,0.303,1.166,0.453,1.769c0.108,0.434,0.215,0.868,0.319,1.304 c0.136,0.572,0.27,1.147,0.404,1.749c0.098,0.44,0.195,0.881,0.289,1.323c0.119,0.558,0.234,1.116,0.348,1.686 c0.097,0.489,0.191,0.978,0.282,1.468c0.099,0.532,0.199,1.067,0.297,1.643c0.008,0.048,0.016,0.096,0.024,0.144 c0.075,0.434,0.147,0.87,0.217,1.306c0.085,0.527,0.17,1.055,0.251,1.595c0.084,0.563,0.161,1.128,0.237,1.693l0.005,0.039 c0.064,0.47,0.128,0.94,0.186,1.408c0.065,0.523,0.122,1.049,0.18,1.575l0.049,0.439c0.044,0.38,0.086,0.76,0.124,1.144 c0.016,0.159,0.028,0.32,0.043,0.48c0.034,0.358,0.065,0.716,0.095,1.074l0.053,0.602c0.03,0.344,0.061,0.686,0.085,1.012 c0.049,0.657,0.086,1.317,0.126,1.976l0.028,0.455c0.016,0.258,0.034,0.515,0.047,0.791c0.042,0.843,0.071,1.688,0.096,2.536 l0.024,0.669c0.027,1.089,0.042,2.181,0.042,3.277c0,0.008,0,0.015,0,0.023c0,25.333-7.301,48.991-19.9,68.992L295.658,275.305z M268.921,290.589c0,1.81-1.471,3.281-3.28,3.281h-19.28c-1.809,0-3.28-1.472-3.28-3.281c0-1.809,1.471-3.281,3.28-3.281h19.28 C267.45,287.308,268.921,288.78,268.921,290.589z"></path> </g> </g> </g></svg>
										</div>
										<div className="flex-grow p-1 font-semibold text-lg text-center">
											{workContentData ? workContentData[1]?.title : null}
										</div>
										<div className="flex-grow p-1 text-center text-base min-h-[60px]">
											{workContentData ? workContentData[1]?.subTille : null}
										</div>

									</div>
									<div className=" h-40 mt-10 border-r-2 border-gray-500"></div>
									{/* Card 3 */}
									<div className="relative flex flex-col justify-center items-center w-80 ">
										<div className="relative overflow-hidden bg-clip-border rounded-xl h-40">
											<svg fill="#233c64" height="150" width="150" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" stroke="#233c64"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g> <g> <g> <path d="M511.999,234.558l-0.002-165.43C511.998,31.01,480.987,0,442.869,0H277.441c-2.829,0-5.541,1.124-7.541,3.124 l-32.337,32.337c-5.529-0.46-11.108-0.832-16.73-1.104c-71.146-3.446-131.857,8.964-154.665,31.614 c-9.137,9.075-10.756,18.199-10.507,24.253c0.904,21.842,27.038,41.488,72.317,54.821L20.177,252.847 C7.166,265.858,0.001,283.218,0.001,301.728c0,18.511,7.166,35.87,20.176,48.879l140.059,140.06h-10.902 c-5.89,0-10.667,4.775-10.667,10.667c0,5.89,4.776,10.667,10.667,10.667h213.331c5.89,0,10.667-4.776,10.667-10.667 c0-5.891-4.776-10.667-10.667-10.667H260.309l248.565-248.565C510.876,240.1,511.999,237.387,511.999,234.558z M76.977,89.342 c-0.039-0.959-0.16-3.88,4.225-8.235C95.91,66.5,144.739,52.399,217.456,55.568l-72.098,72.098 C95.895,115.222,77.335,97.991,76.977,89.342z M244.068,476.737c-8.981,8.982-20.985,13.929-33.796,13.929 c-12.813,0-24.815-4.946-33.795-13.929L35.261,335.521c-8.982-8.98-13.929-20.982-13.929-33.794 c0-12.813,4.947-24.815,13.929-33.796L245.552,57.642c30.865,3.228,59.361,9.437,82.052,18.02 c15.049,5.693,25.198,11.572,31.565,16.862c-7.687,7.721-12.448,18.359-12.448,30.091c0,3.309,0.391,6.528,1.108,9.622 c0.048,0.262,0.112,0.522,0.181,0.781c0.027,0.111,0.052,0.223,0.081,0.334c0.002,0.009,0.005,0.018,0.009,0.026 c4.781,18.332,21.478,31.902,41.287,31.902c23.525,0,42.665-19.139,42.665-42.666c0-23.527-19.139-42.668-42.665-42.668 c-3.784,0-7.452,0.501-10.947,1.43c-9.035-9.546-23.582-18.214-43.289-25.668c-20.087-7.598-44.272-13.446-70.477-17.188 l17.185-17.186h161.009c26.354,0,47.795,21.441,47.795,47.795l0.002,161.011L244.068,476.737z M389.31,104.461 c-0.044-1.06-0.153-2.113-0.311-3.162c0.13-0.002,0.257-0.02,0.388-0.02c11.762,0,21.331,9.571,21.331,21.334 c0,11.762-9.569,21.332-21.331,21.332c-7.336,0-13.817-3.723-17.658-9.378C386.604,123.999,389.647,112.639,389.31,104.461z"></path> <path d="M457.45,90.13c-5.621,1.761-8.751,7.746-6.99,13.367c1.939,6.192,2.923,12.623,2.923,19.116 c0,35.289-28.708,63.997-63.996,63.997c-35.29,0-63.998-28.708-63.998-63.997c0-5.891-4.775-10.667-10.667-10.667 c-5.891,0-10.667,4.775-10.667,10.667c0,47.051,38.279,85.33,85.331,85.33c47.05,0,85.329-38.279,85.329-85.33 c0-8.658-1.311-17.236-3.899-25.493C469.056,91.498,463.07,88.368,457.45,90.13z"></path> <path d="M443.241,81.562c2.657,0,5.319-0.988,7.389-2.975c4.247-4.081,4.383-10.833,0.302-15.082 c-1.75-1.823-3.591-3.578-5.473-5.215c-4.444-3.869-11.181-3.402-15.05,1.041c-3.868,4.443-3.402,11.18,1.042,15.049 c1.405,1.223,2.783,2.538,4.097,3.904C437.642,80.465,440.438,81.562,443.241,81.562z"></path> <path d="M311.212,327.954c1.967-2.759,3.727-5.595,5.223-8.469c9.554-18.349,7.793-40.86-4.486-57.347 c-11.115-14.925-28.314-21.81-46.006-18.416c-12.667,2.429-24.743,9.281-36.422,15.908c-2.682,1.522-5.216,2.96-7.764,4.352 c-15.616,8.521-30.525,9.123-39.884,1.609c-7.723-6.202-10.293-16.948-6.878-28.745c0.987-3.405,2.737-6.727,5.044-9.897 l17.643,17.645c2.083,2.082,4.813,3.124,7.543,3.124c2.73,0,5.458-1.041,7.541-3.124c4.165-4.164,4.166-10.918,0-15.085 l-17.014-17.017c7.679-5.078,16.419-8.945,24.505-10.931c5.721-1.406,9.218-7.184,7.811-12.906 c-1.407-5.721-7.184-9.22-12.906-7.811c-11.379,2.797-23.941,8.377-34.804,16.251l-8.151-8.151 c-4.164-4.164-10.917-4.165-15.085,0c-4.166,4.164-4.166,10.918-0.001,15.085l7.666,7.667 c-4.645,5.781-8.256,12.211-10.285,19.216c-5.805,20.049-0.436,39.71,14.014,51.313c16.302,13.089,40.025,13.27,63.458,0.483 c0.819-0.447,1.639-0.909,2.46-1.364l47.167,47.167c-10.256,8.062-21.897,12.006-29.134,9.714 c-5.617-1.78-11.611,1.332-13.39,6.949c-1.779,5.616,1.332,11.611,6.948,13.389c3.596,1.138,7.325,1.669,11.119,1.669 c13.508-0.001,27.808-6.724,39.561-16.618l11.264,11.265c2.083,2.083,4.813,3.124,7.541,3.124c2.731,0,5.46-1.042,7.542-3.124 c4.165-4.165,4.165-10.918,0.001-15.085L311.212,327.954z M297.514,309.63c-0.523,1.005-1.088,1.986-1.672,2.953l-41.935-41.936 c5.562-2.77,11.006-5.005,16.054-5.973c9.611-1.842,18.676,1.877,24.88,10.206C302.266,284.85,303.314,298.491,297.514,309.63z"></path> <path d="M136.523,363.737c-4.164-4.166-10.918-4.169-15.085-0.004c-4.166,4.164-4.167,10.918-0.003,15.086l4.364,4.366 c2.083,2.084,4.815,3.126,7.545,3.126c2.729,0,5.458-1.04,7.54-3.122c4.166-4.164,4.169-10.918,0.004-15.086L136.523,363.737z"></path> <path d="M232.902,414.863l-22.628,22.629l-45.255-45.257c-4.165-4.165-10.919-4.165-15.085-0.001 c-4.166,4.165-4.166,10.919-0.001,15.086l45.257,45.257c4.159,4.158,9.621,6.238,15.085,6.238c5.462,0,10.926-2.079,15.086-6.238 l22.628-22.628c4.165-4.165,4.165-10.919,0-15.086C243.822,410.697,237.068,410.697,232.902,414.863z"></path> </g> </g> </g> </g></svg>
										</div>
										<div className="flex-grow p-1 font-semibold text-lg text-center">
											{workContentData ? workContentData[2]?.title : null}
										</div>
										<div className="flex-grow p-1 text-center text-base min-h-[60px]">
											{workContentData ? workContentData[2]?.subTille : null}
										</div>
									</div>



								</div>
							</div>
						</div>
						{/* <div className={`w-full flex flex-row items-center h-64 px-10 secondary-${color}  border-y border-black border-opacity-20`}>
								<div className="flex flex-col w-1/2 text-md m-4 p-4">
									<div className="text-2xl font-bold py-3 uppercase ">{partnerConentData ? partnerConentData[0]?.title : null}</div>
									<div className="text-md  text-justify">{partnerConentData ? partnerConentData[0]?.description : null}
									</div>
								</div>
								<div className="flex w-1/2">
									{partnerConentData && partnerConentData[0]?.src ? <img src={partnerConentData[0]?.src} width="600" height="300" />
										: <img src={'https://via.placeholder.com/1000x337'} width="600" height="300" />}

								</div>
							</div> */}

					</div >}
			</div>
			{/* } */}
		</>
	)
}

export default LogisticHome
